/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface APIError {
  /**
   * a custom Oneleet error code
   * @format uint64
   * @example 1400
   */
  code: number;
  /** The type of error. */
  type: ErrorType;
  /**
   * a description for this error
   * @example "Bad request (detailed error)"
   */
  description: string;
  /** a link to the documentation for this error, if it exists */
  docs_link?: string;
}

/**
 * The type of error.
 * @example "RECORD_ALREADY_EXISTS"
 */
export enum ErrorType {
  SLUG_ALREADY_EXISTS = "SLUG_ALREADY_EXISTS",
  MEMBER_ALREADY_EXISTS = "MEMBER_ALREADY_EXISTS",
  EMPLOYEE_ALREADY_EXISTS = "EMPLOYEE_ALREADY_EXISTS",
  INVITE_ALREADY_EXISTS = "INVITE_ALREADY_EXISTS",
  EXTERNAL_ACCOUNT_ALREADY_EXISTS = "EXTERNAL_ACCOUNT_ALREADY_EXISTS",
  DOMAIN_ALREADY_ADDED = "DOMAIN_ALREADY_ADDED",
  DOMAIN_ALREADY_VERIFIED = "DOMAIN_ALREADY_VERIFIED",
  TXT_RECORD_NOT_FOUND = "TXT_RECORD_NOT_FOUND",
  TRUST_REQUEST_ALREADY_SUBMITTED = "TRUST_REQUEST_ALREADY_SUBMITTED",
  EVIDENCE_ALREADY_LINKED = "EVIDENCE_ALREADY_LINKED",
  GROUP_ALREADY_LINKED = "GROUP_ALREADY_LINKED",
}

/** @example {"next_page":3,"num_pages":10,"current_page":2} */
export interface PaginationResponse {
  /**
   * the current page
   * @format int64
   * @example 2
   */
  current_page: number;
  /**
   * the next page
   * @format int64
   * @example 3
   */
  next_page: number;
  /**
   * the total number of pages for listing
   * @format int64
   * @example 10
   */
  num_pages: number;
}

export interface Meta {
  env: Env;
}

export interface Env {
  SENTRY_ENVIRONMENT: string;
  SENTRY_REPLAY_ENABLED: boolean;
  POSTHOG_PUBLIC_API_KEY: string;
  POSTHOG_PUBLIC_PROJECT_ID: string;
  BRANDFETCH_CLIENT_ID: string;
  IS_DEV_ENVIRONMENT: boolean;
  CODE_SECURITY_SCANNER_ENABLED: boolean;
  PEOPLE_PAGE_REDESIGN_ENABLED: boolean;
}

export interface Tenant {
  /**
   * The ID of the tenant.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this tenant was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this tenant was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The name of the tenant. */
  name: string;
  /** The slug of the tenant. */
  slug?: string;
  /** The suggested slug of the tenant. */
  recommendedSlug: string;
  /** The engagements associated with this tenant. */
  engagements?: Engagement[];
  /** The members associated with this tenant. */
  members?: TenantMember[];
  /** The compliance frameworks this tenant has active. */
  complianceFrameworks?: ComplianceFramework[];
  /** The service level agreement in hours for resolving general vulnerabilities. omitted indicates disabled. */
  slaGeneralHours?: number;
  /** The service level agreement in hours for signing policies. omitted indicates disabled. */
  slaPolicySigningHours?: number;
  /** The service level agreement in hours for completing security training. omitted indicates disabled. */
  slaSecurityTrainingHours?: number;
  /** The service level agreement in hours for completing vendor assessments. omitted indicates disabled. */
  slaVendorAssessmentHours?: number;
  /** The service level agreement in hours for completing access reviews. omitted indicates disabled. */
  slaAccessReviewHours?: number;
  /** The service level agreement in hours for completing risk assessments. omitted indicates disabled. */
  slaRiskAssessmentHours?: number;
  /** The service level agreement in hours for resolving informational vulnerabilities. omitted indicates disabled. */
  slaInformationalHours?: number;
  /** The service level agreement in hours for resolving low-severity vulnerabilities. omitted indicates disabled. */
  slaLowSeverityHours?: number;
  /** The service level agreement in hours for resolving medium-severity vulnerabilities. omitted indicates disabled. */
  slaMediumSeverityHours?: number;
  /** The service level agreement in hours for resolving high-severity vulnerabilities. omitted indicates disabled. */
  slaHighSeverityHours?: number;
  /** The service level agreement in hours for resolving critical vulnerabilities. omitted indicates disabled. */
  slaCriticalHours?: number;
}

export interface TenantList {
  pagination?: PaginationResponse;
  rows?: Tenant[];
}

export interface UpdateTenantRequest {
  /**
   * the name for the tenant
   * @example "My Tenant"
   */
  name?: string;
  /**
   * the slug for the tenant
   * @example "mytenant"
   */
  slug?: string;
  /**
   * the service level agreement in hours for resolving general vulnerabilities.
   * @min 0
   */
  slaGeneralHours?: number;
  /**
   * the service level agreement in hours for signing policies.
   * @min 0
   */
  slaPolicySigningHours?: number;
  /**
   * the service level agreement in hours for completing security training.
   * @min 0
   */
  slaSecurityTrainingHours?: number;
  /**
   * the service level agreement in hours for completing vendor assessments.
   * @min 0
   */
  slaVendorAssessmentHours?: number;
  /**
   * the service level agreement in hours for completing access reviews.
   * @min 0
   */
  slaAccessReviewHours?: number;
  /**
   * the service level agreement in hours for completing risk assessments.
   * @min 0
   */
  slaRiskAssessmentHours?: number;
  /**
   * the service level agreement in hours for resolving informational vulnerabilities.
   * @min 0
   */
  slaInformationalHours?: number;
  /**
   * the service level agreement in hours for resolving low-severity vulnerabilities.
   * @min 0
   */
  slaLowSeverityHours?: number;
  /**
   * the service level agreement in hours for resolving medium-severity vulnerabilities.
   * @min 0
   */
  slaMediumSeverityHours?: number;
  /**
   * the service level agreement in hours for resolving high-severity vulnerabilities.
   * @min 0
   */
  slaHighSeverityHours?: number;
  /**
   * the service level agreement in hours for resolving critical vulnerabilities.
   * @min 0
   */
  slaCriticalHours?: number;
  clear?: {
    /** Whether to clear the SLA for general vulnerabilities. */
    slaGeneralHours?: boolean;
    /** Whether to clear the SLA for signing policies. */
    slaPolicySigningHours?: boolean;
    /** Whether to clear the SLA for completing security training. */
    slaSecurityTrainingHours?: boolean;
    /** Whether to clear the SLA for completing vendor assessments. */
    slaVendorAssessmentHours?: boolean;
    /** Whether to clear the SLA for completing access reviews. */
    slaAccessReviewHours?: boolean;
    /** Whether to clear the SLA for completing risk assessments. */
    slaRiskAssessmentHours?: boolean;
    /** Whether to clear the SLA for resolving informational vulnerabilities. */
    slaInformationalHours?: boolean;
    /** Whether to clear the SLA for resolving low-severity vulnerabilities. */
    slaLowSeverityHours?: boolean;
    /** Whether to clear the SLA for resolving medium-severity vulnerabilities. */
    slaMediumSeverityHours?: boolean;
    /** Whether to clear the SLA for resolving high-severity vulnerabilities. */
    slaHighSeverityHours?: boolean;
    /** Whether to clear the SLA for resolving critical vulnerabilities. */
    slaCriticalHours?: boolean;
  };
}

export interface TenantMember {
  /**
   * The ID of the tenant member.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The name of the tenant member. */
  name: string;
  /** The type of the tenant member. */
  type: TenantMemberType;
  /** The role of this tenant member. */
  role: TenantRole;
  /** The status of this tenant member. */
  status: TenantMemberStatus;
  /**
   * The time that this tenant member was last reminded of tasks to complete.
   * @format date-time
   */
  lastTasksReminderSentAt?: string;
  /** The user associated with this tenant member. */
  user?: User;
  /** The public user information associated with this tenant member. */
  userPublic?: UserPublic;
  /** The tenant associated with this tenant member. */
  tenant?: Tenant;
  /**
   * The ID of the tenant associated with this tenant member.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The groups this tenant member is a part of. */
  groups?: Group[];
  /** The devices associated with this tenant member. */
  devices?: TenantDevice[];
  /** The external accounts associated with this tenant member. */
  externalAccounts?: ExternalAccountBase[];
  /**
   * The time that this tenant member was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this tenant member was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** Whether or not to disable notifications for this tenant member. */
  enableNotifications?: boolean;
}

export interface TenantMemberList {
  pagination?: PaginationResponse;
  rows?: TenantMember[];
}

/** A policy that is applicable to a particular tenant member. */
export interface TenantMemberApplicablePolicy {
  /** The policy associated with this personally applicable policy. */
  policy: Policy;
  /** The policy signature associated with this personally applicable policy, if any. */
  signature?: PolicySignature;
  /** Whether or not this tenant member has signed this policy. */
  hasSigned: boolean;
}

export enum TenantMemberType {
  EMPLOYEE = "EMPLOYEE",
  CONTRACTOR = "CONTRACTOR",
  GUEST = "GUEST",
}

export enum TenantRole {
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  AUDITOR = "AUDITOR",
  EMPLOYEE = "EMPLOYEE",
  FORMER_EMPLOYEE = "FORMER_EMPLOYEE",
}

export enum TenantMemberStatus {
  NOT_ONBOARDED = "NOT_ONBOARDED",
  ONBOARDING = "ONBOARDING",
  CURRENT = "CURRENT",
  OFFBOARDING = "OFFBOARDING",
  FORMER = "FORMER",
}

export interface TenantInvite {
  /**
   * The ID of the tenant invite.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this tenant invite was sent.
   * @format date-time
   */
  sentAt: string;
  /**
   * The time that this tenant invite was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this tenant invite was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The email address of the tenant member that created this invite.
   * @format email
   */
  inviterEmail: string;
  /**
   * The email address of the person who was invited.
   * @format email
   */
  inviteeEmail: string;
  /** The name of the person who was invited. */
  inviteeName?: string;
  /** The role of this tenant invite. */
  role: TenantRole;
  /** The tenant associated with this tenant invite. */
  tenant?: Tenant;
  /**
   * The ID of the tenant associated with this tenant invite.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The tenant member associated with this tenant invite. */
  tenantMember?: TenantMember;
  /**
   * The ID of the tenant member associated with this tenant invite.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantMemberId?: string;
  /**
   * The time that this tenant invite expires.
   * @format date-time
   */
  expires: string;
  /** The status of this tenant invite. */
  status: TenantInviteStatus;
}

export interface TenantInviteList {
  pagination?: PaginationResponse;
  rows?: TenantInvite[];
}

export enum TenantInviteStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  DISABLED = "DISABLED",
}

export interface CreateTenantInviteRequest {
  /**
   * The email address of the client to invite.
   * @format email
   * @maxLength 2000
   */
  email: string;
  /**
   * The name of the client to invite.
   * @maxLength 256
   */
  name?: string;
  /** The role to assign to the client in the tenant */
  role: TenantRole;
}

export interface CreateTenantRequest {
  /**
   * the name for the tenant
   * @example "My Tenant"
   */
  name: string;
}

export interface UpdateTenantMemberRequest {
  /**
   * The name of the tenant member.
   * @maxLength 256
   */
  name?: string;
  /** The type of the tenant member. */
  type?: TenantMemberType;
  /** The role of this tenant member. */
  role?: TenantRole;
  /** The status of this tenant member. */
  status?: TenantMemberStatus;
  /** The group IDs this tenant member is a part of. */
  groupIds?: string[];
  /** Whether or not to disable notifications for this tenant member. */
  enableNotifications?: boolean;
}

export interface DeleteTenantMemberRequest {
  /**
   * The ID of the tenant member.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
}

export interface RemindMembersTasksRequest {
  reminders: {
    /**
     * The ID of the tenant member.
     * @format uuid
     * @minLength 36
     * @maxLength 36
     */
    memberId: string;
    /** The tasks to remind the user to complete in the Oneleet Portal */
    portalTasks: PortalTask[];
  }[];
}

export enum PortalTask {
  REVIEW_POLICIES = "REVIEW_POLICIES",
}

export interface TenantDashboard {
  type?: "COMPLIANCE_DASHBOARD" | "CLASSIC_DASHBOARD";
  data?:
    | ({
        type: "CLASSIC_DASHBOARD";
      } & ClassicDashboard)
    | ({
        type: "COMPLIANCE_DASHBOARD";
      } & TenantComplianceDashboard);
}

export interface ClassicDashboard {
  type: string;
  /** The reports associated with this tenant dashboard. */
  reports: DashboardReport[];
  /** The number of findings associated with this tenant dashboard. */
  findingsCount: number;
  /** The number of closed findings associated with this tenant dashboard. */
  closedOrRejectedFindingsCount: number;
}

export interface TenantComplianceDashboard {
  type: string;
  /** The number of closed findings associated with this tenant dashboard. */
  closedOrRejectedFindingsCount: number;
  /** The number of findings associated with this tenant dashboard. */
  totalFindingsCount?: number;
  /** The tasks associated with this tenant dashboard. */
  pendingTasks: Task[];
  /** The number of completed controls associated with this tenant dashboard. */
  completedControlsCount: number;
  /** The number of controls associated with this tenant dashboard. */
  totalControlsCount: number;
  /** The stats associated with this tenant dashboard. */
  dashboardStats?: DashboardStats;
}

export interface AddFeatureFlagRequest {
  /** The ID of the feature flag. */
  id: string;
}

export interface TrustPage {
  companyName?: string;
  customTitle?: string;
  customPageName?: string;
  headerColor?: string;
  accentColor?: string;
  logo?: string;
  favicon?: string;
  backlink?: string;
  email?: string;
  displaySubprocessors?: boolean;
  subprocessors?: TrustSubprocessor[];
  complianceFrameworks?: PublicTenantComplianceFramework[];
  controls?: PublicControlsCategory[];
  /** @format date-time */
  lastUpdatedAt?: string;
  documents?: TrustDocument[];
}

export type TrustPageGetResponse = TrustPage & {
  subprocessors?: TrustSubprocessor[];
};

export interface TrustSubprocessor {
  /** The name of the subprocessor. */
  name?: string;
  /** URL to the subprocessor's logo */
  icon?: string;
  /** An array of services this subprocessor provides */
  services?: string[];
  /** An array of countries in which this subprocessor processes personal data */
  processingLocations?: string[];
  /** If true, indicates this subprocessor processes personally identifiable information. */
  processesPii?: boolean;
  /** URL of the vendor */
  vendorUrl?: string;
}

export interface TrustPageConfigsResponse {
  isPublished: boolean;
  displaySubprocessors?: boolean;
  subprocessorTenantVendorIds?: string[];
  customTitle?: string;
  customPageName?: string;
  headerColor?: string;
  accentColor?: string;
  logo?: string;
  favicon?: string;
  backlink?: string;
  email?: string;
}

export interface TrustPageConfigsUpdate {
  isPublished?: boolean;
  displaySubprocessors?: boolean;
  subprocessorTenantVendorIds?: string[];
  customTitle?: string;
  customPageName?: string;
  headerColor?: string;
  accentColor?: string;
  removeLogo?: boolean;
  removeFavicon?: boolean;
  backlink?: string;
  email?: string;
}

export interface TrustPageLogoUpdateRequest {
  /**
   * Supported types are image/png, image/jpeg, image/webp
   * @format binary
   */
  upload: File;
}

export interface TrustPageFaviconUpdateRequest {
  /**
   * Supported types are image/png, img/ico
   * @format binary
   */
  upload: File;
}

export interface TrustDocument {
  /**
   * The ID of the trust page document.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the tenant.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The name of the trust page document. */
  name: string;
  /** The type of the trust page document. */
  type: TrustDocumentType;
  /** The visibility of the trust page document. */
  visibility: TrustDocumentVisibility;
  /** The order of the trust page document. */
  order: number;
  /** The policy ID of the trust page document. */
  policyId?: string;
  /** The pentest report ID of the trust page document. */
  pentestReportId?: string;
  /** The evidence ID of the trust page document. */
  evidenceId?: string;
  /** The audit ID of the trust page document. */
  auditId?: string;
  /** The download URL of the trust page document. */
  downloadUrl?: string;
  /** The raw markdown the browser can use to render a downloadable PDF. */
  rawMarkdownToRender?: string;
}

export enum TrustDocumentType {
  POLICY = "POLICY",
  PENTEST_REPORT = "PENTEST_REPORT",
  EVIDENCE_LIBRARY = "EVIDENCE_LIBRARY",
  AUDIT_REPORT = "AUDIT_REPORT",
}

export enum TrustDocumentVisibility {
  PUBLIC = "PUBLIC",
  REQUEST_ONLY = "REQUEST_ONLY",
}

/** An array of trust page documents to upsert. */
export type TrustDocumentCreateRequest = {
  /** The ID of the trust page document used to update it. */
  id?: string;
  /** The name of the trust page document. */
  name?: string;
  /** The type of the trust page document. */
  type?: TrustDocumentType;
  /** The visibility of the trust page document. */
  visibility?: TrustDocumentVisibility;
  /** The order of the trust page document. */
  order?: number;
  /** The policy ID of the trust page document. */
  policyId?: string;
  /** The pentest report ID of the trust page document. */
  pentestReportId?: string;
  /** The evidence ID of the trust page document. */
  evidenceId?: string;
  /** The audit ID of the trust page document. */
  auditId?: string;
}[];

export interface TenantSettings {
  /** Whether to show the tenant's review requests in the admin dashboard. */
  enableControlReviews?: boolean;
  /** The slack channel URL for the tenant. */
  slackChannelUrl?: string;
}

export interface UpdateTenantSettingsRequest {
  /**
   * The ID of the tenant to update.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** Whether to show the tenant's review requests in the admin dashboard. */
  enableControlReviews?: boolean;
  /** The slack channel URL for the tenant. */
  slackChannelUrl?: string;
}

export interface AuditLog {
  /**
   * The timestamp of the audit log.
   * @format date-time
   */
  timestamp: string;
  /** The user associated with the audit log. */
  actor: string;
  /** The ID of the user associated with the audit log. */
  actorId: string;
  /** The type of resource associated with the audit log. */
  resourceType: string;
  /** The ID of the resource associated with the audit log. */
  resourceId: string;
  /** The name of the resource associated with the audit log. */
  resourceName: string;
  /** The type of the parent resource associated with the audit log. */
  parentResourceType?: string;
  /** The ID of the parent resource associated with the audit log. */
  parentResourceId?: string;
  /** The name of the parent resource associated with the audit log. */
  parentResourceName?: string;
  /** The IP address associated with the audit log. */
  ip?: string;
  /** The country associated with the audit log. */
  country?: string;
  /** The user agent associated with the audit log. */
  userAgent?: string;
  /** The operation associated with the audit log. */
  operation: string;
  /** The tenant role associated with the audit log. */
  tenantRole?: string;
  /** The metadata associated with the audit log. */
  metadata?: string;
}

export interface AuditLogList {
  /** The cursor to use to get the next page of audit logs. */
  cursor?: string;
  rows: AuditLog[];
}

export interface Group {
  /**
   * The ID of the group.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time the evidence was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the evidence was last updated
   * @format date-time
   */
  updatedAt: string;
  /** The name of the group. */
  name: string;
  /** The description of the group. */
  description?: string;
  /** The id of the tenant this group belongs to */
  tenantId: string;
  members: TenantMember[];
  policies: Policy[];
}

export interface CreateGroupRequest {
  /** The name of the group. */
  name: string;
  /** The description of the group. */
  description?: string;
  /** The ids of the members to add to the group. */
  tenantMemberIds?: string[];
}

export interface UpdateGroupRequest {
  /** The name of the group. */
  name?: string;
  /** The description of the group. */
  description?: string;
  /** The ids of the group's members. */
  tenantMemberIds?: string[];
}

export interface FrameworkStats {
  /** The ID of the framework */
  id: string;
  /** The name of the framework */
  name: string;
  /** Minimal framework information for dashboard display */
  tenantFramework?: DashboardFramework;
  requirements?: FrameworkRequirementStats;
  controls: FrameworkControlStats;
}

export interface FrameworkRequirementStats {
  /** The total number of requirements */
  count: number;
  /** The number of requirements that have been met */
  metCount: number;
}

export interface FrameworkControlStats {
  /** The total number of controls */
  count: number;
  /** The number of controls that are passing */
  passingCount: number;
  /** The number of controls that are in review */
  inReviewCount: number;
  /** The number of controls that are in progress */
  inProgressCount: number;
  /** The number of controls that are failing */
  failingCount: number;
  /** The number of controls that need changes */
  needChangesCount: number;
  /** The number of controls that are not started */
  notStartedCount: number;
}

export interface VulnerabilityStats {
  pentestFindings: PentestFindingCounts;
  codeHealthScanner: CodeHealthFindingCounts;
  codeSecurityScanner: CodeSecurityIssueCounts;
  vulnerabilityScanFindings: VulnerabilityScanFindingCounts;
}

export interface PeopleStats {
  /** The number of people that are compliant */
  compliantCount: number;
  /** The number of people that are not compliant */
  nonCompliantCount: number;
  /** The total number of people */
  count: number;
}

export interface DeviceStats {
  /** The total number of devices */
  count: number;
  /** The number of devices that are compliant */
  compliantCount: number;
  /** The number of devices that are not compliant */
  nonCompliantCount: number;
}

export interface DashboardStats {
  devices: DeviceStats;
  people: PeopleStats;
  vulnerabilities: VulnerabilityStats;
  frameworks: FrameworkStats[];
  audits: DashboardAudit[];
}

/** Minimal framework information for dashboard display */
export interface DashboardFramework {
  /** The ID of the tenant framework */
  id?: string;
  /** The ID of the framework */
  frameworkId: string;
  /** Minimal framework info containing only fields used in dashboard */
  framework: DashboardFrameworkInfo;
}

/** Minimal framework info containing only fields used in dashboard */
export interface DashboardFrameworkInfo {
  /** The ID of the framework */
  id: string;
  /** The icon URL for the framework */
  icon?: string;
}

/** Minimal audit information for dashboard display */
export interface DashboardAudit {
  /**
   * The ID of the audit.
   * @format uuid
   */
  id: string;
  /**
   * The ID of the framework.
   * @format uuid
   */
  frameworkId: string;
  auditType: AuditType;
  /** The stage of the audit. */
  currentStage: AuditStage;
  /**
   * The start of the observation period.
   * @format date-time
   */
  observationPeriodStart?: string;
  /**
   * The end of the observation period.
   * @format date-time
   */
  observationPeriodEnd?: string;
  /** The URL of the report. */
  reportUrl?: string;
}

/** Minimal report information for dashboard display */
export interface DashboardReport {
  /**
   * The ID of the report.
   * @format uuid
   */
  id: string;
  /** The title of the report. */
  title: string;
  /**
   * The ID of the engagement.
   * @format uuid
   */
  engagementId: string;
}

export interface CodeHealthFindingCounts {
  /** The total number of findings */
  count: number;
  /** The number of unresolved findings */
  unresolvedCount: number;
}

export interface CodeSecurityIssueCounts {
  /** The total number of issue */
  count: number;
  /** The number of unresolved issues */
  unresolvedCount: number;
}

export interface PentestFindingCounts {
  /** The total number of findings */
  count: number;
  /** The number of unresolved findings */
  unresolvedCount: number;
}

export interface VulnerabilityScanFindingCounts {
  /** The total number of findings */
  count: number;
  /** The number of unresolved findings */
  unresolvedCount: number;
}

export interface Engagement {
  /**
   * The ID of the engagement.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this engagement was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this engagement was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The name of the engagement. */
  name: string;
  /** The status of the engagement. */
  status: EngagementStatus;
  /** The testers associated with this engagement. */
  testers?: TenantTester[];
  /**
   * The ID of the tenant associated with this engagement.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The tenant associated with this engagement. */
  tenant?: Tenant;
  /** The reports associated with this engagement. */
  reports?: Report[];
  /** The metadata associated with this engagement. */
  meta?: EngagementMeta | null;
  /** The scoping information associated with this engagement. */
  engagementScoping?: EngagementScoping;
}

export interface EngagementMeta {
  /**
   * The planned start time of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  plannedStartAt?: string;
  /**
   * The planned finish time of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  plannedFinishAt?: string;
  /**
   * The actual start time of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  actualStartedAt?: string;
  /**
   * The actual finish time of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  actualFinishedAt?: string;
  /**
   * The period of the engagement.
   * @minLength 1
   * @maxLength 20
   */
  period?: string;
  /**
   * The title of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  title?: string;
  /**
   * The hours of the engagement.
   * @minLength 1
   * @maxLength 255
   */
  hours?: string;
}

export interface EngagementScoping {
  /**
   * The date of the scoping call for the engagement.
   * @format date-time
   */
  scopingCallDate?: string;
  /** The time of the scoping call for the engagement. */
  scopingCallTime?: string;
  /** The details of the scoping call for the engagement. */
  details?: string;
}

export enum EngagementStatus {
  PENDING_SCOPING_CALL = "PENDING_SCOPING_CALL",
  PLANNED = "PLANNED",
  ONGOING = "ONGOING",
  COMPLETED = "COMPLETED",
}

export interface EngagementList {
  pagination?: PaginationResponse;
  rows?: Engagement[];
}

export interface CreateEngagementRequest {
  /** The name of the engagement. */
  name: string;
}

export interface UpdateEngagementRequest {
  /** The name of the engagement. */
  name?: string;
  /** The status of the engagement. */
  status?: EngagementStatus;
  /** The metadata associated with this engagement. */
  meta?: EngagementMeta;
  /** The scoping information associated with this engagement. */
  engagementScoping?: EngagementScoping;
}

export enum EngagementResourceSnapshotOperationKind {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

export enum EngagementResourceSnapshotKind {
  FINDING = "FINDING",
}

export interface EngagementResourceSnapshot {
  /**
   * The ID of the snapshot.
   * @format uuid
   */
  id?: string;
  /**
   * The time that this snapshot was created.
   * @format date-time
   */
  createdAt?: string;
  /** The kind of the snapshot. */
  kind?: EngagementResourceSnapshotKind;
  /** The ID of the kind of the snapshot. */
  kindId?: string;
  /** The email of the user that created the snapshot. */
  userEmail?: string;
  /** The display name of the user that created the snapshot. */
  userDisplayName?: string;
  /** The operation kind of the snapshot. */
  operationKind?: EngagementResourceSnapshotOperationKind;
  /** Json with the update data of the snapshot. */
  updateData?: string;
}

export interface TenantVendorWithReviewer {
  /**
   * The ID of the vendor to review.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId: string;
  /**
   * The ID of the tenant member who is the reviewer.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reviewerId: string;
}

export interface CreateAccessReviewRequest {
  /** The title of the access review. */
  title: string;
  /**
   * The ID of the tenant member who owns the access review.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ownerId: string;
  /**
   * The due date of the access review.
   * @format date-time
   */
  dueBy: string;
  /** The tenant's vendors to review. */
  tenantVendors: TenantVendorWithReviewer[];
}

export interface UpdateAccessReviewRequest {
  /** The title of the access review. */
  title?: string;
  /**
   * The ID of the tenant member who owns the access review.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ownerId?: string;
  /**
   * The due date of the access review.
   * @format date-time
   */
  dueBy?: string;
  status?: AccessReviewStatus;
}

export interface UpdateAccessReviewVendorRequest {
  /**
   * The ID of the tenant member who is the reviewer for this access review vendor.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reviewerId?: string;
}

export interface UpdateAccessReviewAccountRequest {
  status?: AccessReviewAccountStatus;
  changeType?: AccessReviewAccountChangeType;
  /** Note on why the account needs changes or other. */
  note?: string;
}

export enum AccessReviewAccountStatus {
  PENDING = "PENDING",
  NEEDS_CHANGES = "NEEDS_CHANGES",
  CONFIRMED = "CONFIRMED",
}

export enum AccessReviewAccountChangeType {
  GRANT_ACCESS = "GRANT_ACCESS",
  CHANGE_ROLE = "CHANGE_ROLE",
  REMOVE_ACCESS = "REMOVE_ACCESS",
}

export enum AccessReviewVendorStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  REVIEWED = "REVIEWED",
}

export enum AccessReviewStatus {
  PLANNED = "PLANNED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export interface AccessReview {
  /**
   * The ID of the access review.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The title of the access review. */
  title: string;
  status: AccessReviewStatus;
  owner: TenantMember;
  /**
   * The start date of the access review.
   * @format date-time
   */
  startedAt?: string;
  /**
   * The completion date of the access review.
   * @format date-time
   */
  completedAt?: string;
  /**
   * The time the access review was deleted.
   * @format date-time
   */
  deletedAt?: string;
  /**
   * The due date of the access review.
   * @format date-time
   */
  dueBy: string;
  /** The vendors marked for review. */
  vendors: AccessReviewVendor[];
}

export interface AccessReviewVendor {
  /**
   * The ID of the vendor to review.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the tenant vendor.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId: string;
  vendor: Vendor;
  status: AccessReviewVendorStatus;
  reviewer?: TenantMember;
  risk?: TenantVendorRisk;
  /** The accounts to review. */
  accessReviewAccounts: AccessReviewAccount[];
}

export interface AccessReviewAccount {
  /**
   * The ID of the account.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the account in the external system.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  externalAccountId: string;
  externalAccount: ExternalAccount;
  reviewStatus: AccessReviewAccountStatus;
  changeType?: AccessReviewAccountChangeType;
  /** Note on why the account needs changes or other. */
  note?: string;
  reviewer?: TenantMember;
  /**
   * The date the account was reviewed.
   * @format date-time
   */
  reviewedAt?: string;
  /**
   * The ID of the vendor the account belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  accessReviewVendorId: string;
  /**
   * The ID of the tenant vendor.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId?: string;
  vendor: Vendor;
}

export interface AccessReviewAccountForTenantMember {
  accessReviewAccount: AccessReviewAccount;
  vendor: Vendor;
}

export interface CreateAccessReviewAccountRequest {
  /** The email of the account. */
  email: string;
  /**
   * The ID of the tenant member who owns the account.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ownerId?: string;
  /** The name of the workspace the account belongs to. */
  workspaceName?: string;
  roles?: string[];
  /** Whether the account is enabled for MFA. */
  isMfaEnabled?: boolean;
  /**
   * The ID of the access review vendor to add the account to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  accessReviewVendorId: string;
}

export interface ChecklistTemplateItem {
  /**
   * The ID of the checklist template item.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * When this checklist template item was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When this checklist template item was updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the checklist template this item belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  checklistTemplateId: string;
  /** The label of the checklist item. */
  label: string;
}

export enum ChecklistType {
  ONBOARDING = "ONBOARDING",
  OFFBOARDING = "OFFBOARDING",
}

export enum ChecklistItemStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export interface ChecklistTemplate {
  /**
   * The ID of the checklist template.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * When this checklist template was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When this checklist template was updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the tenant the template belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The type of checklist */
  type: ChecklistType;
  items: ChecklistTemplateItem[];
}

export interface ChecklistTemplateList {
  pagination?: PaginationResponse;
  rows?: ChecklistTemplate[];
}

export interface CreateChecklistTemplateRequest {
  /** The type of checklist */
  type: ChecklistType;
}

export interface CreateChecklistTemplateItemRequest {
  /** The label for the checklist item */
  label: string;
  /** The index for the checklist item */
  order?: number;
}

export interface UpdateChecklistTemplateItemRequest {
  /** The new label for the checklist item */
  label?: string;
  /** The new index for the checklist item */
  order?: number;
}

export interface MemberChecklistItem {
  /**
   * The ID of the checklist item.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * When this checklist item was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When this checklist item was updated.
   * @format date-time
   */
  updatedAt: string;
  /** The label of the checklist item. */
  label: string;
  /** The status of the checklist item. */
  status: ChecklistItemStatus;
  /**
   * The ID of the checklist this item belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  memberChecklistId: string;
}

export interface MemberChecklist {
  /**
   * The ID of the checklist.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The type of checklist */
  type: ChecklistType;
  /**
   * When this checklist was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When this checklist was updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the checklist template this checklist was created from.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  checklistTemplateId: string;
  items: MemberChecklistItem[];
}

export interface MemberChecklists {
  pagination?: PaginationResponse;
  rows?: MemberChecklist[];
}

export interface CreateMemberChecklistRequest {
  /**
   * The ID of the checklist template to create a checklist from.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  checklistTemplateId: string;
}

export interface UpdateMemberChecklistRequest {
  /** The new status for all checklist items */
  itemStatuses: ChecklistItemStatus;
}

export interface CreateMemberChecklistItemRequest {
  /** The label for the checklist item */
  label: string;
}

export interface UpdateMemberChecklistItemRequest {
  /** The new label for the checklist item */
  label?: string;
  /** The new index for the checklist item */
  order?: number;
  /** The new status for the checklist item */
  status?: ChecklistItemStatus;
}

export interface TenantTester {
  /**
   * The ID of the tenant tester.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
  /**
   * The time that this tenant tester was created.
   * @format date-time
   */
  createdAt?: string;
  /**
   * The time that this tenant tester was last updated.
   * @format date-time
   */
  updatedAt?: string;
  /** The version of the tenant tester. */
  version?: number;
  /** Whether or not this tenant tester is unassigned. */
  unassigned?: boolean;
  /**
   * The ID of the engagement that this tenant tester is associated with.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  engagementId?: string;
  /**
   * The ID of the user associated with this tenant tester.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  userId?: string;
  /** The user associated with this tenant tester. */
  user?: User;
  /** The public user information associated with this tenant tester. */
  userPublic?: UserPublic;
}

export interface TenantTesterList {
  pagination?: PaginationResponse;
  rows?: TenantTester[];
}

export interface TesterInvite {
  /**
   * The ID of the tenant tester.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this tenant tester was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this tenant tester was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The engagement associated with this tester invite. */
  engagement?: Engagement;
}

export interface TesterInviteList {
  pagination?: PaginationResponse;
  rows?: TesterInvite[];
}

export interface CreateTesterInviteRequest {
  /**
   * The email address of the tester to invite.
   * @format email
   */
  email: string;
  /**
   * The ID of the engagement to invite the user to (optional).
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  engagementId?: string;
}

export interface AssignTesterRequest {
  /**
   * The ID of the engagement to assign the tester to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  engagementId: string;
}

export interface UnassignTesterRequest {
  /**
   * The ID of the engagement to assign the tester to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  engagementId: string;
}

export interface User {
  /**
   * The ID of the user.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this user was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this user was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The name of the user. */
  name: string;
  /**
   * The email address of the user.
   * @format email
   */
  email: string;
  /** Whether the user has verified their email address. */
  emailVerified: boolean;
  oneleetRole: OneleetRole;
}

export interface Superadmin {
  /**
   * The ID of the user.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The name of the user. */
  name: string;
  /**
   * The email address of the user.
   * @format email
   */
  email: string;
}

export interface UserList {
  pagination?: PaginationResponse;
  rows?: User[];
}

export interface UserPublic {
  /** The email address of the user. */
  email: string;
  /** The name of the user. */
  name: string;
}

export enum OneleetRole {
  SUPERADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  PENTESTER = "PENTESTER",
  PENTESTER_ADMIN = "PENTESTER_ADMIN",
}

export interface UserLogin {
  /**
   * The email address of the user.
   * @format email
   */
  email: string;
  /** The password of the user. */
  password: string;
}

export interface UserRegister {
  /** The name of the user. */
  name: string;
  /**
   * The email address of the user.
   * @format email
   */
  email: string;
  /** The password of the user. */
  password: string;
}

export interface PolicyType {
  id: string;
  /** The name of this policy type. */
  name: string;
  /**
   * The time that this policy type was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this policy type was updated.
   * @format date-time
   */
  updatedAt: string;
}

/** A list of policy types. */
export interface PolicyTypeList {
  pagination?: PaginationResponse;
  rows?: PolicyType[];
}

export interface PolicyTemplate {
  /** The ID of the policy template. */
  id: string;
  /** The name of the policy template. */
  name: string;
  /** The description of the policy template. */
  description: string;
  /** The types of the policy template. */
  types: PolicyType[];
  /** The sort order of the policy template. */
  sortOrder: number;
  /** The markdown content of the policy template. */
  markdown: string;
  /**
   * The time that this policy template was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this policy template was last updated.
   * @format date-time
   */
  updatedAt: string;
}

/** A list of policy templates. */
export interface PolicyTemplateList {
  pagination?: PaginationResponse;
  rows?: PolicyTemplate[];
}

export interface Policy {
  /** The ID of the policy. */
  id: string;
  /** The name of the policy. */
  name: string;
  /** The description of the policy. */
  description?: string;
  /** The types of the policy. */
  types?: PolicyType[];
  /** The audience of the policy. */
  audience: PolicyAudience;
  /** Groups that need to sign this policy, if the audience is GROUPS */
  groups?: Group[];
  /** Groups that are excluded from needing to sign this policy */
  excludedGroups?: Group[];
  /** The current version of the policy. */
  currentVersion: PolicyVersion;
  /** The ID of the tenant associated with this policy. */
  tenantId: string;
  /**
   * The time that this policy was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this policy was last updated.
   * @format date-time
   */
  updatedAt: string;
}

export enum PolicyAudience {
  EVERYONE = "EVERYONE",
  EMPLOYEES = "EMPLOYEES",
  CONTRACTORS = "CONTRACTORS",
  GROUPS = "GROUPS",
}

/** A list of policies. */
export interface PolicyList {
  pagination?: PaginationResponse;
  rows?: Policy[];
}

/** A policy version. */
export interface PolicyVersion {
  /** The ID of the policy version. */
  id: string;
  /** The ID of the policy associated with this policy version. */
  policyId: string;
  /** The version number of the policy. */
  versionNumber: number;
  /** The minor version number of the policy. */
  minorVersionNumber: number;
  /** The markdown content of the policy version. */
  markdown?: string;
  /** Whether or not this policy version is published. */
  isPublished: boolean;
  /**
   * The time that this policy version was published.
   * @format date-time
   */
  publishedAt?: string;
  /**
   * The time that this policy version was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this policy version was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The signatures associated with this policy version. */
  directSignatures?: PolicySignature[];
  /** Signatures from previous minor versions that count towards this policy version. */
  inheritedSignatures?: PolicySignature[];
  /** Combined signatures and inherited signatures that count towards this policy version */
  applicableSignatures?: PolicySignature[];
  /** The tenant members that need to sign this policy version, including their signatures if they have signed. */
  applicableTenantMembers?: PolicyApplicableTenantMember[];
  /** The policy's file name. */
  fileName?: string;
  /** The policy's file url. */
  fileUrl?: string;
}

/** A list of policy versions. */
export interface PolicyVersionList {
  pagination?: PaginationResponse;
  rows?: PolicyVersion[];
}

/** A tenant member that needs to sign a policy. */
export interface PolicyApplicableTenantMember {
  /** The tenant member associated with this required signature. */
  tenantMember: TenantMember;
  /** The policy signature associated with this required signature. */
  signature?: PolicySignature;
  /** Whether or not this tenant member has signed this policy. */
  hasSigned: boolean;
}

/** A policy signature. */
export interface PolicySignature {
  /** The ID of the policy signature. */
  id: string;
  /** The ID of the policy associated with this policy signature. */
  policyVersionId: string;
  /** The user associated with this policy signature. */
  user: UserPublic;
  /**
   * The time that this policy signature was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this policy signature was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The policy version associated with this policy signature. */
  policyVersion?: PolicyVersion;
}

/** A list of policy signatures. */
export interface PolicySignatureList {
  pagination?: PaginationResponse;
  rows?: PolicySignature[];
}

export interface CreatePolicyRequest {
  /** The name of the policy. */
  name: string;
  /** The description of the policy. */
  description?: string;
  /** The IDs of the policy types associated with this policy. */
  typeIds?: string[];
  /** The markdown content of the policy. */
  markdown?: string;
  /** The ID of the policy template this policy was created from, if any */
  templateId?: string;
  /**
   * Supported types application/pdf
   * @format binary
   */
  upload?: File;
}

export interface UpdatePolicyRequest {
  /** The name of the policy. */
  name?: string;
  /** The description of the policy. */
  description?: string;
  /** The IDs of the policy types associated with this policy. */
  typeIds?: string[];
  /** The audience of the policy. */
  audience?: PolicyAudience;
  /** The group IDs that need to sign this policy, if audience is GROUPS */
  groupIds?: string[];
  /** The group IDs that are excluded from needing to sign this policy, regardless of audience */
  excludedGroupIds?: string[];
}

/** A request to update a policy version. */
export interface UpdatePolicyVersionRequest {
  /** The markdown content of the policy version. */
  markdown?: string;
  /**
   * Supported types application/pdf
   * @format binary
   */
  upload?: File;
}

/** A request to publish a policy version. */
export interface PublishPolicyVersionRequest {
  /** Whether or not this policy version is a major revision (only applicable for subsequent versions) */
  isMajorRevision?: boolean;
}

export interface SharedData {
  /** The tenant associated with this shared data. */
  tenant: SharedDataTenant;
  /** The user associated with this shared data. */
  user: User;
}

export interface SharedDataTenant {
  /** The name of the tenant. */
  name: string;
}

export interface Report {
  /**
   * The ID of the report.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this report was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this report was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The title of the report. */
  title: string;
  /** The version of the report. */
  version: number;
  /** The version notes of the report. */
  versionNotes?: string;
  /** If the report was requested. */
  reportRequested: boolean;
  /**
   * The ID of the engagement that this report is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  engagementId: string;
  /** The snapshots associated with this report. */
  snapshots?: ReportSnapshot[];
  /** The report meta associated with this report. */
  reportMeta?: ReportMeta;
  /** The preface section associated with this report. */
  prefaceSection?: PrefaceSection;
  /** The findings section associated with this report. */
  findingsSection?: FindingsSection;
  /** The customs section associated with this report. */
  customSections?: CustomSection[];
}

export interface ReportList {
  pagination?: PaginationResponse;
  rows?: Report[];
}

export interface ReportSnapshot {
  /**
   * The ID of the report snapshot.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this report snapshot was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this report snapshot was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The version of the report snapshot. */
  version: number;
  /** The version notes of the report snapshot. */
  versionNotes?: string;
  /**
   * The ID of the report that this snapshot is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reportId: string;
  /**
   * The time that this report snapshot was published.
   * @format date-time
   */
  publishedAt?: string;
  /** The user that published this report snapshot. */
  publishedBy?: string;
  /** The raw report data. */
  rawReport?: object;
}

export interface ReportVersion {
  /** The ID of the report version. */
  id: string;
  /** The version of the report version. */
  version: number;
  /** The version notes of the report version. */
  versionNotes: string;
  /** The ID of the report that this version is linked to. */
  reportId: string;
  /** The kind of report version. */
  kind: "snapshot" | "report";
}

export interface ReportVersionList {
  pagination?: PaginationResponse;
  rows?: ReportVersion[];
}

export interface ReportMeta {
  /**
   * The ID of the report meta.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this report meta was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this report meta was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the report that this meta is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reportId: string;
  /**
   * The score of the report.
   * @min 1
   * @max 10
   */
  score?: number;
  /** The positive findings of the report. */
  positiveFindings?: string;
  /** The recommendations of the report. */
  recommendations?: string;
}

export interface PrefaceSection {
  /**
   * The ID of the preface section.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the report that this preface section is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reportId: string;
  hosts?: PrefaceSectionHost[];
}

export interface PrefaceSectionHost {
  /**
   * The ID of the preface section host.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the preface section that this host is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  prefaceSectionId: string;
  /** The hostname of the host. */
  hostname: string;
  /** The IP address of the host. */
  ip: string;
  /** The description of the host. */
  description: string;
}

export interface FindingsSection {
  /**
   * The ID of the findings section.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the report that this findings section is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reportId: string;
  findings?: Finding[];
}

export interface CustomSection {
  /**
   * The ID of the custom section.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the report that this custom section is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reportId: string;
  /** The markdown content of the section. */
  markdown: string;
}

export interface CreateReportRequest {
  /**
   * the title of the report
   * @example "My Report"
   */
  title: string;
}

export interface UpdateReportRequest {
  /** the title of the report */
  title?: string;
  /** the version notes of the report */
  versionNotes?: string;
  /**
   * the score of the report
   * @min 1
   * @max 10
   */
  score?: number;
  /** the positive findings of the report */
  positiveFindings?: string;
  /** the recommendations of the report */
  recommendations?: string;
  /** the hosts of the report */
  hosts?: {
    /** The hostname of the host. */
    hostname: string;
    /** The IP address of the host. */
    ip: string;
    /** The description of the host. */
    description: string;
  }[];
}

export interface CreateImageResponse {
  /** The path to the image */
  imageURI: string;
}

export interface ReportDownloadResponse {
  /**
   * The URL of the report.
   * @format url
   */
  reportURL: string;
}

export interface TrustDocumentRequest {
  requesterName: string;
  requesterEmail: string;
  requesterCompany: string;
  requestedDocuments: string[];
  captchaToken: string;
}

export type TrustDocumentRequestUpdate = {
  /** @format uuid */
  id: string;
  status: TrustDocumentUpdateStatus;
  /** The raw HTML of the markdown that the backend can use to render a downloadable PDF. */
  rawHtmlToRender?: string;
}[];

export interface TrustDocumentResponse {
  /** @format uuid */
  id: string;
  status: TrustDocumentStatus;
  /** @format date-time */
  createdAt: string;
  requesterName: string;
  requesterEmail: string;
  requesterCompany: string;
  document?: TrustDocument;
}

export enum TrustDocumentStatus {
  PENDING = "PENDING",
  DENIED = "DENIED",
  APPROVED = "APPROVED",
}

export enum TrustDocumentUpdateStatus {
  DENIED = "DENIED",
  APPROVED = "APPROVED",
}

export enum TrustSecurityIssueStatus {
  OPEN = "OPEN",
  RESOLVED = "RESOLVED",
}

export interface TrustSecurityIssueRequest {
  reporterName: string;
  reporterEmail: string;
  reporterCompany: string;
  description: string;
  captchaToken: string;
}

export interface TrustSecurityIssueRequestUpdate {
  /** @format uuid */
  id: string;
  status: TrustSecurityIssueStatus;
}

export interface TrustSecurityIssueResponse {
  /** @format uuid */
  id: string;
  status: TrustSecurityIssueStatus;
  /** @format date-time */
  createdAt: string;
  reporterName: string;
  reporterEmail: string;
  reporterCompany: string;
  description: string;
}

export interface Finding {
  /**
   * The ID of the finding.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this finding was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this finding was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the findings section that this finding is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  findingsSectionId?: string;
  /**
   * The ID of the tester that generated this finding.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  testerId?: string;
  tester?: TenantTester;
  /** The readable ID of the finding. */
  readableId: string;
  /**
   * The date that the finding was discovered.
   * @format date-time
   */
  discoveryDate: string;
  /** The title of the finding. */
  title: string;
  /** The kind of the finding. */
  kind: FindingKind;
  /** The state of the finding. */
  state: FindingState;
  /** The source of the finding. */
  source: FindingSource;
  /** The priority of the finding. */
  priority: FindingPriority;
  /** The reason for triggering the finding to be closed. */
  reviewReason?: FindingCloseReason;
  /** Additional text that a tester can add for the review. */
  reviewReasonText?: string;
  targets?: Target[];
  classification?: FindingClassification;
  findingText?: FindingText;
  snapshots?: EngagementResourceSnapshot[];
  /**
   * The date that the finding was last requested assistance.
   * @format date-time
   */
  lastRequestAssistanceAt?: string;
  findingSection?: FindingsSectionForFindingObject;
}

export interface FindingsSectionForFindingObject {
  /**
   * The ID of the findings section.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
  report?: Report;
}

export interface FindingList {
  pagination?: PaginationResponse;
  rows?: Finding[];
}

export interface FindingText {
  /**
   * The ID of the finding text.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the finding that this finding text is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  findingId: string;
  /** The general description of the finding. */
  generalDescription: string;
  /** The technical description of the finding. */
  technicalDescription?: string;
  /** The specific description of the finding. */
  specificDescription?: string;
  /** The reproduction steps of the finding. */
  reproductionSteps?: string;
  /** The references of the finding. */
  references?: string;
  /** The remediation of the finding. */
  remediation?: string;
  /** The business impact of the finding. */
  businessImpact?: string;
  /** The additional info of the finding. */
  additionalInfo?: string;
}

export interface FindingClassification {
  /**
   * The ID of the finding classification.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the finding that this finding classification is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  findingId: string;
  /** The risk of the finding. */
  risk: ClassificationRisk;
  /** The probability of the finding. */
  probability: ClassificationProbability;
  /** The impact of the finding. */
  impact: ClassificationImpact;
  /** The CWE of the finding. */
  cwe?: string;
  /** The OWASP of the finding. */
  owasp?: string;
  /** The CVSS version of the finding. */
  cvssVersion?: string;
  /** The CVSS base score of the finding. */
  cvssBaseScore?: number;
  /** The CVSS base severity of the finding. */
  cvssBaseSeverity?: string;
  /** The CVSS vector of the finding. */
  cvssVector?: string;
}

export interface Target {
  /**
   * The ID of the target.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the finding that this target is linked to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  findingId: string;
  /** The kind of the target. */
  kind: TargetKind;
  /** The host:port of the target. */
  hostPort?: string;
  /** The filepath of the target. */
  filepath?: string;
  /** The ports associated with this target. */
  ports?: SubdomainPort[];
  subdomain?: Subdomain;
  /**
   * The ID of the subdomain that this target belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  subdomainId?: string;
}

export enum TargetKind {
  SUBDOMAINPORT = "SUBDOMAINPORT",
  HOSTPORT = "HOSTPORT",
  FILEPATH = "FILEPATH",
}

export enum FindingKind {
  VULNERABILITY = "VULNERABILITY",
  INFORMATIONAL = "INFORMATIONAL",
}

export enum ClassificationImpact {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  NOTAVAILABLE = "NOTAVAILABLE",
}

export enum ClassificationProbability {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  NOTAVAILABLE = "NOTAVAILABLE",
}

export enum ClassificationRisk {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  NOTE = "NOTE",
}

export enum FindingState {
  DRAFT = "DRAFT",
  OPEN = "OPEN",
  REMEDIATED = "REMEDIATED",
  IN_REVIEW = "IN_REVIEW",
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  DUPLICATE = "DUPLICATE",
  ACCEPTED_RISK = "ACCEPTED_RISK",
  FALSE_POSITIVE = "FALSE_POSITIVE",
  IGNORED = "IGNORED",
}

export enum FindingCloseReason {
  TEST_FOR_REMEDIATION = "TEST_FOR_REMEDIATION",
  REJECTED = "REJECTED",
  ACCEPTED_RISK = "ACCEPTED_RISK",
  FALSE_POSITIVE = "FALSE_POSITIVE",
  CLOSED_OTHER = "CLOSED_OTHER",
}

export enum FindingSource {
  PENTEST = "PENTEST",
  BUGBOUNTY = "BUGBOUNTY",
  VULN_SCAN = "VULN_SCAN",
  ATTACK_SURFACE_SCAN = "ATTACK_SURFACE_SCAN",
  STATIC_CODE_ANALYSIS = "STATIC_CODE_ANALYSIS",
}

export enum FindingPriority {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  INFORMATIONAL = "INFORMATIONAL",
}

export interface CreateTargetRequest {
  /** The kind of the target. */
  kind: TargetKind;
  /**
   * The host:port of the target.
   * @minLength 1
   * @maxLength 6000
   */
  hostPort?: string;
  /**
   * The filepath of the target.
   * @minLength 1
   * @maxLength 6000
   */
  filepath?: string;
}

export interface CreateFindingRequest {
  /**
   * The title of the finding.
   * @minLength 1
   * @maxLength 100
   */
  title: string;
  /**
   * The readable ID of the finding.
   * @minLength 1
   * @maxLength 12
   */
  readableId: string;
  /** The state of the finding. */
  state?: FindingState;
  /** The kind of the finding. */
  kind: FindingKind;
  /** The priority of the finding. */
  priority?: FindingPriority;
  /** The impact of the finding. */
  impact: ClassificationImpact;
  /** The probability of the finding. */
  probability: ClassificationProbability;
  /** The risk of the finding. */
  risk: ClassificationRisk;
  /**
   * The general description of the finding.
   * @minLength 1
   * @maxLength 64560
   */
  generalDescription: string;
  /**
   * The ID of the tester that created the finding.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  testerId?: string;
  targets?: CreateTargetRequest[];
  /**
   * The specific description of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  specificDescription?: string;
  /**
   * The reproduction steps of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  reproductionSteps?: string;
  /**
   * The business impact of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  businessImpact?: string;
  /**
   * The remediation of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  remediation?: string;
}

export interface UpdateFindingRequest {
  /**
   * The title of the finding.
   * @minLength 1
   * @maxLength 100
   */
  title?: string;
  /**
   * The readable ID of the finding.
   * @minLength 1
   * @maxLength 24
   */
  readableId?: string;
  /** The state of the finding. */
  state?: FindingState;
  /** The kind of the finding. */
  kind?: FindingKind;
  /** The priority of the finding. */
  priority?: FindingPriority;
  /** The impact of the finding. */
  impact?: ClassificationImpact;
  /** The probability of the finding. */
  probability?: ClassificationProbability;
  /** The risk of the finding. */
  risk?: ClassificationRisk;
  /**
   * The general description of the finding.
   * @minLength 1
   * @maxLength 64560
   */
  generalDescription?: string;
  /**
   * The ID of the tester that created the finding.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  testerId?: string;
  targets?: CreateTargetRequest[];
  /**
   * The specific description of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  specificDescription?: string;
  /**
   * The reproduction steps of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  reproductionSteps?: string;
  /**
   * The business impact of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  businessImpact?: string;
  /**
   * The remediation of the finding.
   * @minLength 1
   * @maxLength 6000
   */
  remediation?: string;
}

export interface RequestRemediationRequest {
  /** The reason for requesting remediation. */
  reviewReason: FindingCloseReason;
  /** The reason description for requesting remediation. */
  reviewReasonText: string;
}

export interface CloseByAcceptedRequest {
  /** The reason description for closing. */
  closeReasonText: string;
}

export interface UpdateScanFindingState {
  /** The reason for triggering the finding state to be updated. */
  state?: "REMEDIATED" | "ACCEPTED_RISK" | "FALSE_POSITIVE";
  /** The reason description for updating the scan finding state. */
  updateReason?: string;
}

export interface ComplianceFramework {
  /** The id of the framework. */
  id: string;
  /** The name of the framework. */
  name: string;
  /** The version of the framework. */
  version: string;
  /** The description of the framework. */
  description: string;
  /** The icon for the framework. */
  icon: string;
  /** Whether the framework is available for users to use. */
  isActive?: boolean;
  /** The id of the framework that this framework extends. */
  extendsId?: string;
  /** The framework that this framework extends. */
  extends?: ComplianceFramework;
  /** The requirements for the framework. */
  requirements?: ComplianceRequirement[];
  /**
   * The time the framework was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the framework was last updated
   * @format date-time
   */
  updatedAt: string;
  /** Whether the framework is visible to tenants. */
  isVisibleToTenant?: boolean;
  /** The estimated time to complete the framework. */
  estimatedTime?: string;
  /** The percentage of controls that have already been completed in another framework that overlaps with the new framework. */
  estimatedReadiness: number;
}

export interface ComplianceFrameworkList {
  pagination?: PaginationResponse;
  rows?: ComplianceFramework[];
}

export interface ComplianceRequirement {
  /** The id of the requirement. */
  id: string;
  /** A string that uniquely identifies the requirement in the framework document. The format of this can vary from framework to framework and may not always look exactly like a number. */
  referenceId: string;
  /** The number of the requirement. */
  number: number;
  /** The title of the requirement. */
  title: string;
  /** The description of the requirement. */
  description?: string;
  /** The id of the framework that this requirement belongs to. */
  frameworkId: string;
  /** The framework that this requirement belongs to. */
  framework?: ComplianceFramework;
  /**
   * The time the requirement was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the requirement was last updated
   * @format date-time
   */
  updatedAt: string;
}

export interface ComplianceRequirementList {
  pagination?: PaginationResponse;
  rows?: ComplianceRequirement[];
}

export interface TenantComplianceFramework {
  /** The id of the tenant compliance framework. */
  id: string;
  /** The status of the tenant compliance framework. */
  status: TenantComplianceFrameworkStatus;
  /** Whether the compliance framework is shown on the tenant's trust page. */
  isVisibleOnTrustPage: boolean;
  progress: {
    /** The number of requirements that have been met. */
    metRequirementCount: number;
    /**
     * What percent complete the framework is, ranging from 0 (0%) to 100 (100%).
     * @min 0
     * @max 100
     */
    percentComplete: number;
  };
  /** The id of the tenant this tenant compliance framework belongs to. */
  tenantId: string;
  /** The id of the framework associated with this tenant compliance framework. */
  frameworkId: string;
  /** The framework associated with this tenant compliance framework. */
  framework: ComplianceFramework;
  /** The tenant requirements for this tenant compliance framework. */
  requirements?: TenantComplianceRequirement[];
  /**
   * The time the tenant compliance framework was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the tenant compliance framework record was last updated
   * @format date-time
   */
  updatedAt: string;
  /** The type of SOC2 compliance framework. */
  soc2type: Soc2Type;
}

export enum TenantComplianceFrameworkStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLIANT = "COMPLIANT",
}

export enum Soc2Type {
  TYPE1 = "TYPE_1",
  TYPE2 = "TYPE_2",
  UNSET = "UNSET",
}

export enum PublicTenantComplianceFrameworkStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLIANT = "COMPLIANT",
}

export interface PublicTenantComplianceFramework {
  id: string;
  name: string;
  icon: string;
  status: PublicTenantComplianceFrameworkStatus;
  soc2type?: Soc2Type;
}

export interface TenantComplianceFrameworkList {
  pagination?: PaginationResponse;
  rows?: TenantComplianceFramework[];
}

export interface CreateTenantComplianceFrameworkRequest {
  /** The id of the framework associated with this tenant compliance framework. */
  frameworkId: string;
}

export interface UpdateTenantComplianceFrameworkRequest {
  /** The status of the tenant compliance framework. */
  status?: TenantComplianceFrameworkStatus;
  /** Whether the compliance framework is shown on the tenant's trust page. */
  isVisibleOnTrustPage?: boolean;
  /** The type of SOC2 compliance framework. */
  soc2type?: Soc2Type;
}

export interface TenantComplianceProgramData {
  /** All tenant compliance frameworks */
  frameworks: TenantComplianceFramework[];
  /** All requirements for all frameworks */
  requirements: TenantComplianceRequirement[];
  /** All controls for all frameworks */
  controls: Control[];
}

export interface TenantComplianceRequirement {
  /** The id of the tenant compliance requirement. */
  id: string;
  progress: {
    /** The number of controls associated with this requirement. */
    controlCount: number;
    /** The number of controls that are passing */
    passingControlCount: number;
    /**
     * What percent met the requirement is, ranging from 0 (0%) to 100 (100%).
     * @min 0
     * @max 100
     */
    percentMet: number;
    /** Whether the requirement has been met */
    isMet: boolean;
  };
  /** The id of the tenant framework that this requirement belongs to. */
  tenantFrameworkId: string;
  /** The tenant framework that this requirement belongs to. */
  tenantFramework?: TenantComplianceFramework;
  /** The id of the requirement associated with this tenant compliance requirement. */
  requirementId: string;
  /** The requirement associated with this tenant compliance requirement. */
  requirement: ComplianceRequirement;
  /**
   * The time the requirement was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the requirement was last updated
   * @format date-time
   */
  updatedAt: string;
  /** The controls associated with this tenant compliance requirement. */
  controls?: Control[];
}

export interface TenantComplianceRequirementList {
  pagination?: PaginationResponse;
  rows?: TenantComplianceRequirement[];
}

export interface Integration {
  /**
   * The ID of the integration.
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this integration was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this integration was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the tenant that this integration belongs to.
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /**
   * The ID of the integration type.
   * @minLength 36
   * @maxLength 36
   */
  integrationTypeId: string;
  integrationType?: IntegrationType;
  /** The additional configuration of the integration. */
  configuration?: object;
  /** The connections for this integration. */
  connections?: Connection[];
  /** The number of monitors for this integration. */
  monitorCount?: number;
  /** The provider we get from Nango for this specific integration. It's used to render the form for the integration. */
  provider?: NangoProvider;
}

/** The provider we get from Nango for this specific integration. It's used to render the form for the integration. */
export interface NangoProvider {
  /** The ID of the provider. */
  id: string;
  /** The authentication type for this provider. */
  authType?: string;
  /** The auth mode for this provider. */
  authMode?:
    | "API_KEY"
    | "APP"
    | "APP_STORE"
    | "BASIC"
    | "NONE"
    | "OAUTH1"
    | "OAUTH2"
    | "OAUTH2_CC"
    | "CUSTOM"
    | "TBA"
    | "TABLEAU"
    | "JWT"
    | "BILL"
    | "TWO_STEP"
    | "SIGNATURE";
  /** Documentation URL for this provider. */
  docs?: string;
  connectionConfig?: Record<string, NangoProviderConnectionConfigField>;
  credentials?: Record<string, NangoProviderConnectionConfigField>;
}

/** The connection config for the provider. */
export interface NangoProviderConnectionConfigField {
  /** The name of the configuration field. */
  name: string;
  /** The type of the configuration field. */
  type: "string";
  /** The human-readable title of the configuration field. */
  title: string;
  /** Description of what this configuration field is for. */
  description: string;
  /** Example value for the configuration field. */
  example?: string;
  /** Regex pattern for validating the configuration field. */
  pattern?: string;
  /** Format hint for the configuration field. */
  format?: "hostname" | "uri" | "uuid" | "email";
  /** The order in which this field should appear in the form. */
  order?: number;
  /** Whether this field contains secret information (like a password or API key). */
  secret?: boolean;
  /** Prefix text to display before the field value. */
  prefix?: string;
  /** Suffix text to display after the field value. */
  suffix?: string;
  /** Whether this field is optional. */
  optional?: boolean;
  /**
   * Reference to a section in the documentation for this field.
   * @pattern ^#[a-z0-9-]+$
   */
  docSection?: string;
  /** Whether this field is automatically handled by the system. */
  automated?: boolean;
}

export interface NangoAuthSessionTokenResponse {
  /** Nango session token, which can be used to initiate a Nango auth flow. */
  token: string;
}

export type NangoAuthCallbackRequest = {
  type: "auth";
} & NangoAuthCallbackPayloadAuth;

export interface NangoAuthCallbackPayloadAuth {
  /** Which type of webhook event this is */
  type: string;
  /** The provider config key for the integration */
  providerConfigKey: string;
  /** Whether the connection was created, re-authorized, or refreshed */
  operation: "creation" | "override" | "refresh";
  /** Nango connection ID of the created/re-authorized/refreshed connection */
  connectionId: string;
  /** Nango integration provider ID (e.g., "openai") */
  provider: string;
  /** End user info that was passed to Nango when the connection flow was initiated (session token generated) */
  endUser: {
    endUserId: string;
    organizationId?: string;
  };
  /** Whether the operation succeeded */
  success: boolean;
  error?: {
    type?: string;
    description?: string;
  };
}

export interface IntegrationList {
  pagination?: PaginationResponse;
  rows?: Integration[];
  /** Whether the response may be incomplete due to service degredation. */
  isPartial: boolean;
}

export interface Connection {
  /**
   * The ID of the connection.
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this connection was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this connection was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the integration.
   * @minLength 36
   * @maxLength 36
   */
  integrationId: string;
  integration?: Integration;
  /**
   * An alternative ID for the connection, which must be unique per tenant.
   *
   * This is used as both a unique identifier in some of our integrations logic,
   * *and* as a user-facing label for the connection.
   *
   * Some integrations populate this with a nice value, such as "project name" for GCP.
   * Due to technical limitations, Nango-based integrations currently don't.
   */
  readableId: string;
  /** User-created label for the connection; if not present, `readableId` is shown as a fallback. */
  label?: string;
  /** The additional configuration of the connection. */
  configuration?: BaseNull & BaseNullIntegrationTypeIdMapping<"aws_v1", CreateAWSConnectionData>;
  status: ConnectionStatus;
  /** The reason for the connection status. */
  statusReason?: string;
  /** The asset statuses for this connection. */
  assetStatuses?: AssetStatus[];
}

export enum ConnectionStatus {
  UNQUERIED = "UNQUERIED",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export interface AssetStatus {
  /**
   * The time that this asset status was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the asset.
   * @maxLength 50
   */
  assetTypeId: string;
  status: AssetStatusEnum;
  /** The reason for the asset status. */
  reason: string;
  /** For failing statuses, the raw requests/responses sent to and received from third party APIs. */
  rawExchanges?: object;
}

export enum AssetStatusEnum {
  UNQUERIED = "UNQUERIED",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export interface CreateGCPConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The ID of the GCP project. */
  gcpProjectId: string;
}

export interface CreateJumpcloudConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The account name for Jumpcloud. */
  jumpcloudAccountName: string;
  /** The API key from the Jumpcloud console. */
  apiKey: string;
}

export interface CreateGitLabConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Group, project, or personal access token name from the GitLab's interface. */
  accessTokenName: string;
  /** Group, project, or personal access token secret from the GitLab's interface. */
  accessTokenSecret: string;
}

export interface CreateAWSConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The ARN of the role that shall be assumed. */
  assumeRoleArn: string;
  /** The AWS region(s) to use. */
  selectedRegions?: string[];
  /** The external ID for the assume role. */
  externalId: string;
}

export interface CreateAWSv2ConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Random identifier used to find the S3 object ubcreated for this template. */
  randomKey: string;
  /** The AWS region(s) to use. */
  selectedRegions: string[];
  /** The primary AWS region to use. */
  primaryRegion: string;
}

export interface CreateCloudflareConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Descriptive name given to the API token. */
  tokenName: string;
  /** API token generated by Cloudflare. */
  tokenSecret: string;
}

export interface CreateVercelConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Vercel Team ID. */
  teamId: string;
  /** Vercel Access Token. */
  accessToken: string;
}

export interface CreateMezmoConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Descriptive name given to the connection. */
  connectionName: string;
  /** Access token generated by Mezmo. */
  accessToken: string;
}

export interface CreateAzureConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The Azure tenant ID. */
  tenantId: string;
  /** The Azure client ID. */
  clientId: string;
  /** The Azure client secret. */
  clientSecret: string;
}

export interface CreateTailscaleConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The OAuth client ID for the Tailscale connection. */
  clientId: string;
  /** The OAuth client secret for the Tailscale connection. */
  clientSecret: string;
}

export interface CreateDopplerConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The Doppler audit token for the connection. */
  auditToken: string;
}

export interface CreateBrexConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Descriptive name given to the API token. */
  tokenName: string;
  /** API token generated by Brex. */
  tokenSecret: string;
}

export interface CreateSupabaseConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** API token generated by Supabase. */
  tokenSecret: string;
}

export interface CreateFlyioConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Access token generated by Fly.io. */
  accessToken: string;
  /** Organization identifier from Fly.io. */
  organizationSlug: string;
}

export interface PreSetupAWSv2ConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The AWS region(s) a tenant could use. */
  availableRegions: string[];
  /**
   * Rendered CloudFormation template for the Oneleet AWS role.
   * @format html
   */
  cloudformationTemplate: string;
  /** Random identifier to be used in the CloudFormation template. Format is UNIXTIME_RANDOMSTRING */
  randomKey: string;
}

export interface PreSetupConnectionResponse {
  data: AbstractNull & AbstractNullIntegrationTypeIdMapping<"aws_v2", PreSetupAWSv2ConnectionData>;
}

export interface VerifyCreateAWSv2ConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Random identifier to be used in the CloudFormation template. Format is UNIXTIME_RANDOMSTRING */
  randomKey: string;
}

export interface VerifyCreateConnectionResponse {
  data: DiscriminatorNull & DiscriminatorNullIntegrationTypeIdMapping<"aws_v2", VerifyCreateAWSv2ConnectionData>;
}

export interface CreateDigitalOceanConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** Descriptive name given to the API token. */
  tokenName: string;
  /** API token generated by DigitalOcean. */
  tokenSecret: string;
}

export type CreateConnectionRequest = BaseCreateConnectionRequest &
  (
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"gcp_v1", CreateGCPConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"jumpcloud_v1", CreateJumpcloudConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"aws_v1", CreateAWSConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"aws_v2", CreateAWSv2ConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"cloudflare_v1", CreateCloudflareConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"gitlab_v1", CreateGitLabConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"vercel_v1", CreateVercelConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"mezmo_v1", CreateMezmoConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"azure_v1", CreateAzureConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"tailscale_v1", CreateTailscaleConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"doppler_v1", CreateDopplerConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"brex_v1", CreateBrexConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"supabase_v1", CreateSupabaseConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"flyio_v1", CreateFlyioConnectionData>
    | BaseCreateConnectionRequestIntegrationTypeIdMapping<"digitalOcean_v1", CreateDigitalOceanConnectionData>
  );

export interface UpdateConnectionConfigurationRequest {
  /** User-created label for the connection */
  label?: string;
  configuration?: InternalNull & InternalNullIntegrationTypeIdMapping<"aws_v1", UpdateAWSConnectionData>;
}

export interface UpdateAWSConnectionData {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The AWS region(s) to use. */
  selectedRegions?: string[];
}

export type ReconnectConnectionRequest = BaseReconnectConnectionRequest &
  (
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"aws_v1", CreateAWSConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"aws_v2", CreateAWSv2ConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"gcp_v1", CreateGCPConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"jumpcloud_v1", CreateJumpcloudConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"cloudflare_v1", CreateCloudflareConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"gitlab_v1", CreateGitLabConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"vercel_v1", CreateVercelConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"mezmo_v1", CreateMezmoConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"azure_v1", CreateAzureConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"tailscale_v1", CreateTailscaleConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"doppler_v1", CreateDopplerConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"brex_v1", CreateBrexConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"supabase_v1", CreateSupabaseConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"flyio_v1", CreateFlyioConnectionData>
    | BaseReconnectConnectionRequestIntegrationTypeIdMapping<"digitalOcean_v1", CreateDigitalOceanConnectionData>
  );

export interface ReconnectAWSConnectionRequest {
  /** The ID of the integration type. */
  integrationTypeId: string;
  /** The ARN of the role that shall be assumed. */
  assumeRoleArn: string;
  /** The AWS region(s) to use. */
  selectedRegions?: string[];
  /** The external ID for the assume role. */
  externalId: string;
}

export interface CreateIntegrationRequest {
  /** The ID of the integration type. */
  integrationTypeId: string;
}

export interface UpdateIntegrationRequest {
  /** The auth token to use with the integration. */
  authToken?: string;
  /** The additional configuration of the integration. */
  configuration?: object;
}

export interface IntegrationType {
  /** The ID of the integration type. */
  id: string;
  /**
   * The time that this integration type was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this integration type was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The name of the integration type. */
  name: string;
  /** The description of the integration type. */
  description: string;
  category?: IntegrationCategory;
  /** Whether or not the integration type requires OAuth. */
  requiresOAuth: boolean;
  inspectorType: "GRAPHQL" | "REST" | "UNSUPPORTED";
  /** Whether or not the integration type is managed by Oneleet. */
  isOneleetManaged: boolean;
  /** Whether or not the integration type is in testing phase, and accessible by "integration-tester" flag. */
  isInTestingPhase: boolean;
  /** Whether or not the integration type has a "Beta" label on the frontend. */
  isMarkedAsBeta: boolean;
  /** Whether or not the integration type can be used with the Code Security module. */
  worksWithCodeSecurity: boolean;
  /** Form tag to choose the form to be rendered on the frontend */
  formTag: string;
  /** Icon to be rendered on the frontend */
  icon: string;
  /** The integrations for this integration type. */
  integrations?: Integration[];
}

export enum IntegrationCategory {
  INTERNAL = "INTERNAL",
  ADMINISTRATION = "ADMINISTRATION",
  CLOUD_PROVIDER = "CLOUD_PROVIDER",
  VERSION_CONTROL = "VERSION_CONTROL",
  OBSERVABILITY = "OBSERVABILITY",
  MOBILE_DEVICE_MANAGEMENT = "MOBILE_DEVICE_MANAGEMENT",
  VULNERABILITY_MANAGEMENT = "VULNERABILITY_MANAGEMENT",
  VPN = "VPN",
  SECRETS_MANAGEMENT = "SECRETS_MANAGEMENT",
  COMMUNICATION = "COMMUNICATION",
  PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",
  FINANCIAL = "FINANCIAL",
  HUMAN_RESOURCES = "HUMAN_RESOURCES",
  SPEND_MANAGEMENT = "SPEND_MANAGEMENT",
  AI_MODELS = "AI_MODELS",
}

export interface IntegrationTypeList {
  pagination?: PaginationResponse;
  rows?: IntegrationType[];
  /** Whether the response may be incomplete due to service degredation. */
  isPartial: boolean;
}

export interface AWSExternalId {
  /** The external ID for the assume role. */
  externalId: string;
}

export interface AWSTemplateUrlRequest {
  /** The primary AWS region to use. */
  primaryRegion: string;
  /** The AWS region(s) to use. */
  selectedRegions: string[];
  /** ID of the existing connection (set when re-connecting), null if not */
  connectionId?: string;
}

export interface AWSTemplateUrlResponse {
  /** Quick-create link for the CloudFormation template for our AWS role. */
  templateUrl: string;
  /** Random identifier to be used in the CloudFormation template. Format is UNIXTIME_RANDOMSTRING */
  randomKey: string;
}

export interface IntegrationInspectorRequest {
  /** The JSON encoded body of the request to pass along to the integration */
  query: string;
}

export interface IntegrationInspectorResponse {
  /** The JSON encoded body of the response returned from the integration */
  result: string;
}

export interface Domain {
  /** The ID of the domain. */
  id: string;
  /**
   * The fully qualified name of the domain.
   * @format hostname
   */
  fqdn: string;
  /** Whether or not the domain has been verified. */
  isVerified: boolean;
  /** The ID of the verification record for this domain. */
  verificationId: string;
  /** The ID of the tenant associated with this domain. */
  tenantId: string;
  /** The tenant associated with this domain. */
  tenant: Tenant;
  /**
   * The date and time the domain was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the domain was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The ingress hostname associated with the domain. */
  ingressHostname?: string;
}

/** A list of domains. */
export interface DomainList {
  pagination?: PaginationResponse;
  rows?: Domain[];
}

export interface CreateDomainRequest {
  /**
   * The fully qualified name of the domain.
   * @format hostname
   */
  fqdn: string;
}

export interface CreateIngressHostnameRequest {
  /**
   * The subdomain specified by the user.
   * @format hostname
   */
  subdomain: string;
}

export interface Subdomain {
  /**
   * The ID of the subdomain.
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this subdomain was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this subdomain was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the tenant that this subdomain belongs to.
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /**
   * The fully qualified domain name of the subdomain.
   * @format hostname
   */
  fqdn: string;
  /**
   * The ID of the root domain that this subdomain belongs to.
   * @minLength 36
   * @maxLength 36
   */
  domainId: string;
  /** The root domain that this subdomain belongs to. */
  domain: Domain;
  /** The number of findings associated with this subdomain. */
  findingCount?: number;
  /** The ports associated with this subdomain. */
  ports?: number[];
}

/** A list of subdomains. */
export interface SubdomainList {
  pagination?: PaginationResponse;
  rows?: Subdomain[];
}

/** A port associated with a subdomain. */
export interface SubdomainPort {
  /**
   * The ID of the port.
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
  /**
   * The time that this port was created.
   * @format date-time
   */
  createdAt?: string;
  /**
   * The time that this port was last updated.
   * @format date-time
   */
  updatedAt?: string;
  /** The port number. */
  port?: number;
  /**
   * The ID of the subdomain that this port belongs to.
   * @minLength 36
   * @maxLength 36
   */
  subdomainId?: string;
  /** The subdomain that this port belongs to. */
  subdomain?: Subdomain;
}

export interface Monitor {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this monitor was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this monitor was updated.
   * @format date-time
   */
  updatedAt: string;
  /** The status of a monitor. */
  status: MonitorStatus;
  /**
   * The time that this monitor's status last changed, if applicable.
   * @format date-time
   */
  statusChangedAt?: string;
  /**
   * The time this monitor started alerting, if applicable.
   * @format date-time
   */
  alertingSince?: string;
  /**
   * The time this monitor will breach SLA, if applicable.
   * @format date-time
   */
  breachesSlaAt?: string;
  /** Whether the monitor is enabled. Default is true. */
  isEnabled: boolean;
  disabledReason?: string;
  /**
   * The time at which to re-review the monitor and potentially re-enable it.
   * @format date-time
   */
  reviewRemindAt?: string;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  configuration?: object;
  results?: MonitorAssetResult[];
  tenant?: Tenant;
  monitorType: MonitorType;
  latestRun?: MonitorRun;
  currentState?: MonitorState;
  stats?: MonitorStats;
}

export interface MonitorList {
  pagination?: PaginationResponse;
  rows?: Monitor[];
}

/** The status of a monitor. */
export enum MonitorStatus {
  BREACHING_SLA = "BREACHING_SLA",
  ALERTING = "ALERTING",
  PASSING = "PASSING",
  NO_APPLICABLE_ASSETS = "NO_APPLICABLE_ASSETS",
  NOT_YET_RUN = "NOT_YET_RUN",
  IGNORED = "IGNORED",
  DISABLED = "DISABLED",
}

export interface MonitorAssetResult {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  monitorId: string;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  assetId: string;
  /** The status of a monitor asset result. */
  status: MonitorAssetResultStatus;
  /** The SLA type of a monitor asset result. */
  slaType: SlaType;
  /**
   * The time that this monitor asset result's status last changed.
   * @format date-time
   */
  statusChangedAt: string;
  /**
   * The time that this monitor asset result started alerting, if applicable.
   * @format date-time
   */
  alertingSince?: string;
  /**
   * The time that this monitor asset result will breach SLA, if applicable.
   * @format date-time
   */
  breachesSlaAt?: string;
  /**
   * The time that this monitor asset result was last run.
   * @format date-time
   */
  lastRunAt: string;
  /**
   * The time that this monitor result was created.
   * @format date-time
   */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  asset?: Asset;
}

/** The status of a monitor asset result. */
export enum MonitorAssetResultStatus {
  BREACHING_SLA = "BREACHING_SLA",
  ALERTING = "ALERTING",
  PASSING = "PASSING",
  IGNORED = "IGNORED",
}

/** The SLA type of a monitor asset result. */
export enum SlaType {
  GENERAL = "GENERAL",
  POLICY_SIGNING = "POLICY_SIGNING",
  SECURITY_TRAINING = "SECURITY_TRAINING",
  VENDOR_ASSESSMENT = "VENDOR_ASSESSMENT",
  RISK_ASSESSMENT = "RISK_ASSESSMENT",
  ACCESS_REVIEW = "ACCESS_REVIEW",
  INFORMATIONAL = "INFORMATIONAL",
  LOW_SEVERITY = "LOW_SEVERITY",
  MEDIUM_SEVERITY = "MEDIUM_SEVERITY",
  HIGH_SEVERITY = "HIGH_SEVERITY",
  CRITICAL = "CRITICAL",
}

export interface MonitorStats {
  assets: MonitorAssetStats;
}

export interface MonitorAssetStats {
  /** The total number of assets detected by this monitor. */
  count: number;
  /** The number of assets passing this monitor. */
  passingCount: number;
  /** The number of assets failing this monitor. */
  failingCount: number;
  /** The percentage of assets passing this monitor. */
  percentPassing: number;
}

export interface MonitorRun {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this monitor was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this monitor was updated.
   * @format date-time
   */
  updatedAt: string;
  /** The status of a monitor run. */
  status: MonitorRunStatus;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  monitorId: string;
}

/** The status of a monitor run. */
export enum MonitorRunStatus {
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

export interface MonitorType {
  /** @maxLength 100 */
  id: string;
  name: string;
  assetType?: AssetType;
  assetTypeId: string;
  /**
   * The time that this monitor was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this monitor was updated.
   * @format date-time
   */
  updatedAt: string;
  rerunDisabled: boolean;
}

export interface MonitorTypeList {
  pagination?: PaginationResponse;
  rows?: MonitorType[];
}

export interface MonitorState {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this monitor state was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this monitor state was updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The time that this monitor state finished.
   * @format date-time
   */
  finishedAt?: string;
  /** The status of a monitor. */
  status: MonitorStateStatus;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  monitorId: string;
  monitor?: Monitor;
  reason: string;
  /** Assets that were impacted during this monitor state period */
  impactedAssets?: MonitorStateImpactedAsset[];
}

/** The status of a monitor. */
export enum MonitorStateStatus {
  INACTIVE = "INACTIVE",
  PASSING = "PASSING",
  ALERTING = "ALERTING",
  BREACHING_SLA = "BREACHING_SLA",
}

export interface MonitorStateList {
  pagination?: PaginationResponse;
  rows?: MonitorState[];
}

export interface MonitorRunList {
  pagination?: PaginationResponse;
  rows?: MonitorRun[];
}

export interface MonitorStateImpactedAsset {
  /**
   * The ID of the asset
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  assetId: string;
  /** The stable instance ID of the asset */
  assetInstanceId: string;
  /** The name of the asset */
  assetName: string;
  /**
   * The ID of the connection
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  connectionId: string;
  /** The human-readable connection identifier */
  connectionReadableId: string;
  /** The label of the connection */
  connectionLabel?: string;
  /** Time periods when this asset was impacted */
  impactedPeriods: ImpactedPeriod[];
}

export interface ImpactedPeriod {
  /** The status of the asset during this period */
  status: MonitorAssetResultStatus;
  /**
   * When this specific status period started
   * @format date-time
   */
  startedAt: string;
  /**
   * When this specific status period ended (null if still ongoing)
   * @format date-time
   */
  endedAt?: string;
  /**
   * Original alerting time (for context)
   * @format date-time
   */
  alertingSince: string;
  /** The SLA type for this period */
  slaType: SlaType;
  /** Reasons for this period */
  reasons: string[];
}

export interface ResultSnapshot {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  connectionId: string;
  connectionReadableId: string;
  /** The status of a result snapshot. */
  status: ResultSnapshotStatus;
  reasons: string[];
  assetResultSnapshot?: AssetResultSnapshot;
}

/** The status of a result snapshot. */
export enum ResultSnapshotStatus {
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  IGNORED = "IGNORED",
}

export interface ResultSnapshotList {
  pagination?: PaginationResponse;
  rows?: ResultSnapshot[];
}

export interface AssetResultSnapshot {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  assetId: string;
  assetName: string;
  assetInstanceId: string;
  resultSnapshot?: ResultSnapshot;
}

export type MonitorUpdateConfig = object;

export interface MonitorUpdateEnabled {
  enabled: boolean;
  disabledReason?: string;
  /** @format date-time */
  reviewRemindAt?: string;
}

export interface MonitorUpdateIgnoreStatusForAssets {
  /** List of assetInstanceId */
  assetsToIgnore: string[];
  reasonToIgnore: string;
  /** List of assetInstanceId */
  assetsToUnignore: string[];
}

export interface Check {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The type of check. */
  type: CheckType;
  /** The status of the check. */
  status: CheckStatus;
  /** Whether or not this check is disabled. */
  isDisabled: boolean;
  /**
   * The time that this check was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this check was updated.
   * @format date-time
   */
  updatedAt: string;
  integrationCategory?: IntegrationCategory;
  integration?: Integration;
  monitor?: Monitor;
  policyType?: PolicyType;
  policy?: Policy;
  evidenceRequestId?: string;
  evidenceRequest?: EvidenceRequest;
}

/** The type of check. */
export enum CheckType {
  INTEGRATION = "INTEGRATION",
  MONITOR = "MONITOR",
  POLICY = "POLICY",
  ATTACHMENT = "ATTACHMENT",
  EVIDENCE_REQUEST = "EVIDENCE_REQUEST",
}

export enum CheckStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  INACTIVE = "INACTIVE",
  PASSING = "PASSING",
  FAILING = "FAILING",
  NEEDS_CHANGES = "NEEDS_CHANGES",
}

export interface CheckList {
  pagination?: PaginationResponse;
  rows?: Check[];
}

export interface Asset {
  /**
   * The ID of the asset.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The instance ID of the asset. */
  assetInstanceId: string;
  /**
   * The date and time the asset was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the asset was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The date and time the asset was deleted.
   * @format date-time
   */
  deletedAt?: string;
  /** The name of the asset. */
  name: string;
  /** The description of the asset. */
  description?: string;
  /** The ID of the asset type associated with this asset. */
  assetTypeId: string;
  /** The asset type associated with this asset. */
  assetType?: AssetType;
  /** The tenant associated with this asset. */
  tenant?: Tenant;
  /** The ID of the tenant associated with this asset. */
  tenantId: string;
  /** The data associated with this asset. */
  data: object;
  /** The ID of the connection associated with this asset. */
  connectionId: string;
  /** The connection associated with this asset. */
  connection?: Connection;
  /** Whether the asset is in scope. */
  isInScope: boolean;
  /**
   * The status of the asset. Because the asset status is an aggregate status of all the monitors
   * that are associated with this asset, we use the same status enum as the MonitorStatus enum.
   */
  status?: MonitorStatus;
}

export interface AssetType {
  /** The ID of the asset type. */
  id: string;
  /**
   * The date and time the asset type was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the asset type was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The date and time the asset type was deleted.
   * @format date-time
   */
  deletedAt?: string;
  /** The name of the asset type. */
  name: string;
  /** The description of the asset type. */
  description: string;
  /** The JSON schema associated with this asset type. */
  jsonSchema?: string;
  /** The assets associated with this asset type. */
  assets: Asset[];
  /** The integration type associated with this asset type. */
  integrationType?: IntegrationType;
  /** The ID of the integration type associated with this asset type. */
  integrationTypeId?: string;
  /** The monitor types associated with this asset type. */
  monitorTypes?: MonitorType[];
}

export interface AssetTypeList {
  pagination: PaginationResponse;
  rows: AssetType[];
}

export enum AssetTypeStatus {
  Ready = "ready",
  Loading = "loading",
  Error = "error",
}

export interface IgnoreAssetGlobally {
  /** The monitor ID from which the global ignore was initiated. */
  monitorId: string;
  /** The reason for ignoring the asset globally. */
  reason: string;
}

/** The request body to assign an asset to a tenant member. */
export interface AssetAssignRequest {
  /**
   * The ID of the tenant member who owns the device.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantMemberId?: string;
}

export interface UpdateAssetRequest {
  /** The name of the device. */
  name?: string;
  /** Whether the device is in scope for it's tenant. */
  isInScope?: boolean;
  /**
   * The ID of the tenant member who owns the device.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ownerId?: string;
}

export interface ControlType {
  /** The id of the control type. */
  id: string;
  /** The default compliance requirements this control type satisfies */
  associatedComplianceRequirements?: ComplianceRequirement[];
  /**
   * The time the control type was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the control type was last updated
   * @format date-time
   */
  updatedAt: string;
  /**
   * The time the control type was deleted.
   * @format date-time
   */
  deletedAt?: string;
  /** The control type's title. */
  title: string;
  /** The control type's description. */
  description: string;
  /** The control type's instructions. */
  instructions?: string;
  /** The control type's framework implementation notes */
  frameworkNotes?: FrameworkNotes[];
  /** The integration categories associated with this control type. */
  integrationCategories?: IntegrationCategory[];
  category?: ControlCategory;
  /** The monitor types associated with this control type. */
  monitorTypes?: MonitorType[];
  inAppDocumentTemplates?: InAppDocumentTemplateMeta[];
}

export interface ControlTypeList {
  pagination?: PaginationResponse;
  rows?: ControlType[];
}

export interface Control {
  /**
   * The ID of the control.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The status of the control. */
  status: ControlStatus;
  /** Whether the control is disabled. */
  isDisabled: boolean;
  /** The manually requested evidence for the control. */
  evidenceRequests?: EvidenceRequest[];
  /** The id of the tenant. */
  tenantId: string;
  /** The tenant that the control belongs to. */
  tenant?: Tenant;
  /** The id of the control type. */
  controlTypeId: string;
  /** This control's attached evidence */
  evidence?: Evidence[];
  /** The checks associated with this control. */
  checks?: Check[];
  /** The tenant compliance requirements associated with this control. */
  tenantComplianceRequirements?: TenantComplianceRequirement[];
  controlType: ControlType;
  content: ControlContent;
  /** The review status of the control. */
  reviewStatus?: ControlReviewStatus;
  /**
   * The time at which the review was requested.
   * @format date-time
   */
  reviewRequestedAt?: string;
  /** The content of the most recent review. */
  reviewDetails?: string;
  /** The name of the user who reviewed the control. */
  reviewerName?: string;
  /**
   * The time the control review was submitted.
   * @format date-time
   */
  reviewedAt?: string;
  /**
   * The time the control was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the control was last updated
   * @format date-time
   */
  updatedAt: string;
  /**
   * The time the control was deleted.
   * @format date-time
   */
  deletedAt?: string;
  assignedMember?: TenantMember;
  /** The reviewer assigned to the control. */
  assignedReviewer?: UserPublic;
}

export enum ControlCategory {
  ACCESS_CONTROL_AND_AUTHORIZATION = "ACCESS_CONTROL_AND_AUTHORIZATION",
  EMAIL_SECURITY = "EMAIL_SECURITY",
  ENDPOINT_SECURITY = "ENDPOINT_SECURITY",
  INFRASTRUCTURE_SECURITY = "INFRASTRUCTURE_SECURITY",
  DATA_MANAGEMENT_AND_PROTECTION = "DATA_MANAGEMENT_AND_PROTECTION",
  VULNERABILITY_MANAGEMENT = "VULNERABILITY_MANAGEMENT",
  MONITORING_AND_INCIDENT_RESPONSE = "MONITORING_AND_INCIDENT_RESPONSE",
  DISASTER_RECOVERY = "DISASTER_RECOVERY",
  RISK_MANAGEMENT = "RISK_MANAGEMENT",
  ORGANIZATIONAL_SECURITY = "ORGANIZATIONAL_SECURITY",
}

/** The status of the control. */
export enum ControlStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  IN_REVIEW = "IN_REVIEW",
  NEEDS_CHANGES = "NEEDS_CHANGES",
  FAILING = "FAILING",
  PASSING = "PASSING",
}

export interface ControlContent {
  /**
   * The control's title.
   * @maxLength 255
   */
  title: string;
  /**
   * The control's description.
   * @maxLength 6000
   */
  description: string;
  /**
   * The control's instructions.
   * @maxLength 6000
   */
  instructions?: string;
}

export interface ControlList {
  pagination?: PaginationResponse;
  rows?: Control[];
}

export interface Evidence {
  /**
   * The ID of the evidence.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The name of the evidence. */
  name?: string;
  /** The type of evidence. */
  type: EvidenceType;
  /** The evidence's file name. */
  fileName?: string;
  /** The evidence's file url. */
  fileUrl?: string;
  /** The evidence's link. */
  link?: string;
  /** The evidence's note. */
  note?: string;
  /** The IDs of linked controls. */
  controlIds: string[];
  /** The IDs of linked vendors. */
  vendorIds?: string[];
  /** The id of the tenant this evidence belongs to */
  tenantId: string;
  createdBy?: UserPublic;
  /**
   * The time the evidence was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time the evidence was last updated
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the in-app document.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  inAppDocumentId?: string;
  inAppDocument?: InAppDocument;
}

/** The type of evidence. */
export enum EvidenceType {
  IMAGE = "IMAGE",
  FILE = "FILE",
  LINK = "LINK",
  NOTE = "NOTE",
  IN_APP_DOCUMENT = "IN_APP_DOCUMENT",
}

export interface EvidenceRequest {
  /**
   * The ID of the requested evidence.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * When this evidence request was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * When this evidence request was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * If set, defines the date this request becomes active, and when evidence can then be submitted.
   * @format date-time
   */
  activeAt?: string;
  /** Title of the evidence being requested. */
  title: string;
  /** Description of the evidence being requested. */
  description?: string | null;
  /**
   * Identifier for the related control
   * @format uuid
   */
  controlId: string;
  /** The review status of the control. */
  reviewStatus?: ControlReviewStatus;
  evidence?: Evidence[];
}

export interface CreateEvidenceRequestRequest {
  evidenceRequests: EvidenceRequestCreateObject[];
}

export interface EvidenceRequestCreateObject {
  /** Title of the evidence being requested. */
  title: string;
  /** Description of the evidence being requested. */
  description?: string | null;
  /**
   * If set, defines the date this request becomes active, and when evidence can then be submitted.
   * @format date-time
   */
  activeAt?: string | null;
}

export interface UpdateEvidenceRequestRequest {
  /** The title of the evidence request. */
  title?: string;
  /** The description of the evidence request. */
  description?: string;
  /**
   * If set, defines the date this request becomes active, and when evidence can then be submitted.
   * @format date-time
   */
  activeAt?: string;
  /** The review status of the evidence request. */
  reviewStatus?: "APPROVED" | "REJECTED";
}

export interface SubmitEvidenceRequestReviewRequest {
  /** The review status of the evidence request. */
  reviewStatus: "APPROVED" | "REJECTED";
}

export interface CreateEvidenceRequest {
  /**
   * The name of the evidence.
   * @maxLength 255
   */
  name?: string;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  controlId?: string;
  /**
   * The id of the evidence request to link to, if applicable.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  evidenceRequestId?: string;
  /** The type of evidence. */
  type: EvidenceType;
  /**
   * Supported types are image/jpeg, image/png, image/webp, image/gif, text/csv, text/markdown, text/plain, application/x-yaml, application/pdf, application/msword,  application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation
   * @format binary
   */
  upload?: File;
  /**
   * The evidence's link.
   * @maxLength 2000
   */
  link?: string;
  /**
   * The evidence's note.
   * @maxLength 10000
   */
  note?: string;
  /**
   * The ID of the in-app document.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  inAppDocumentId?: string;
}

export interface CreateControlRequest {
  /** The id of the control type. */
  controlTypeId: string;
}

export interface UpdateControlCommentRequest {
  /**
   * A new comment on the control.
   * @maxLength 10000
   */
  comment: string;
  /**
   * The plaintext version of the comment.
   * @maxLength 10000
   */
  commentPlaintext: string;
  /**
   * The HTML version of the comment.
   * @maxLength 10000
   */
  commentHtml: string;
}

export interface UpdateControlContentRequest {
  /**
   * The control's custom title.
   * @maxLength 255
   */
  customTitle?: string;
  /**
   * The control's custom description.
   * @maxLength 6000
   */
  customDescription?: string;
  /**
   * The control's custom instructions.
   * @maxLength 6000
   */
  customInstructions?: string;
  /** An object containing any fields that should be cleared. */
  clear?: {
    /** If true, clears the custom title value. */
    customTitle?: boolean;
    /** If true, clears the custom description value. */
    customDescription?: boolean;
    /** If true, clears the custom instructions value. */
    customInstructions?: boolean;
  };
}

export interface UpdateEvidenceRequest {
  /**
   * The name of the evidence.
   * @maxLength 255
   */
  name?: string;
  /**
   * The evidence's link.
   * @maxLength 2000
   */
  link?: string;
  /**
   * The evidence's note.
   * @maxLength 10000
   */
  note?: string;
  /**
   * Supported types are image/jpeg, image/png, image/webp, image/gif, text/csv, text/markdown, text/plain, application/x-yaml, application/pdf, application/msword,  application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation
   * @format binary
   */
  upload?: File;
}

export interface LinkEvidenceRequest {
  /**
   * The id of the control to link to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  controlId: string;
  /**
   * The id of the evidence request to link to, if applicable.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  evidenceRequestId?: string;
}

export interface UnlinkEvidenceRequest {
  /**
   * The id of the control to unlink.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  controlId?: string;
  /**
   * The id of the evidence request to unlink from.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  evidenceRequestId?: string;
}

export interface LinkEvidenceToVendorRequest {
  /**
   * The id of the tenant vendor to link to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId: string;
}

export interface UnlinkEvidenceFromVendorRequest {
  /**
   * The id of the tenant vendor to unlink from.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId: string;
}

export interface PublicControl {
  name: string;
  status: string;
  description: string;
  frameworks: {
    id: string;
    notes?: string;
  }[];
}

export interface PublicControlsCategory {
  category: string;
  controls: PublicControl[];
}

/** The review status of the control. */
export enum ControlReviewStatus {
  UNREVIEWED = "UNREVIEWED",
  IN_REVIEW = "IN_REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface SubmitControlReviewRequests {
  /** The IDs of the controls to be reviewed. */
  controlIds: string[];
  /** The content of the review */
  reviewDetails: string;
  /** The review status of the control. */
  reviewStatus: SubmitControlReviewStatus;
}

/** The review status of the control. */
export enum SubmitControlReviewStatus {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export interface ControlUpdateAssignedMemberRequest {
  /**
   * The content of the review
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  memberId?: string;
}

export interface ControlUpdateAssignedReviewerRequest {
  /**
   * The id of the user to assign to the control review to
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  reviewerId?: string;
}

export interface FeatureFlag {
  /** The ID of the feature flag. */
  id: string;
  /** The label of the feature flag. */
  label: string;
}

export interface FeatureFlagList {
  pagination?: PaginationResponse;
  rows?: FeatureFlag[];
}

export interface FrameworkNotes {
  /** The framework the note is associated with */
  frameworkId?: string;
  /** Implementation details for this framework */
  note?: string;
}

export interface InAppDocumentTemplate {
  /** The id of the document template. */
  id: string;
  /** The title of the document template. */
  title: string;
  /** A description for the document template. */
  description: string;
  /** The body of the document template (editor.js formatted). */
  editorJSBody: DocumentEditorObject;
  /** The control types that allow this document template as evidence. */
  controlTypes?: ControlType[];
}

export interface InAppDocumentTemplateMeta {
  /** The id of the document template. */
  id: string;
  /** The title of the document template. */
  title: string;
  /** A description for the document template. */
  description: string;
}

export interface InAppDocument {
  /** The id of the document. */
  id: string;
  /**
   * The time that this document was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this document was updated.
   * @format date-time
   */
  updatedAt: string;
  /** The title of the document. */
  title: string;
  /** A description for the document. */
  description: string;
  /** The body of the document (editor.js formatted). */
  editorJSBody: DocumentEditorObject;
  /** The template for the document. */
  template?: InAppDocumentTemplate;
  /** The id of the template for the document. */
  templateId?: string;
  /** The id of the tenant that owns the document. */
  tenantId: string;
  /** The user that created the document. */
  user: UserPublic;
  /** The control attachments for the document. */
  usedByEvidence?: Evidence[];
}

export interface InAppDocumentTemplateList {
  pagination?: PaginationResponse;
  rows?: InAppDocumentTemplate[];
}

export interface InAppDocumentList {
  pagination?: PaginationResponse;
  rows?: InAppDocument[];
}

export interface CreateInAppDocumentRequest {
  /** The title of the document. */
  title: string;
  /** A description for the document. */
  description: string;
  /** The body of the document (editor.js formatted). */
  editorJSBody: DocumentEditorObject;
  /** The id of the template for the document. */
  templateId?: string;
}

export interface UpdateInAppDocumentRequest {
  /** The title of the document. */
  title?: string;
  /** A description for the document. */
  description?: string;
  /** The body of the document (editor.js formatted). */
  editorJSBody?: DocumentEditorObject;
}

export interface DocumentEditorObject {
  /**
   * Timestamp in milliseconds
   * @format int64
   */
  time?: number;
  blocks: DocumentEditorBlock[];
  /** Version of the editor */
  version?: string;
}

export interface DocumentEditorBlock {
  /** Unique identifier for the block */
  id: string;
  /** Type of the block */
  type:
    | "table"
    | "header"
    | "paragraph"
    | "list"
    | "image"
    | "checklist"
    | "quote"
    | "code"
    | "inlineCode"
    | "delimiter"
    | "simpleImage"
    | "marker";
  data: object;
}

export interface Workflow {
  /**
   * The time that this workflow was created.
   * @format date-time
   */
  startedAt?: string;
  /**
   * The time that this workflow completed (optional)
   * @format date-time
   */
  finishedAt?: string;
  status: WorkflowStatus;
  type: WorkflowType;
}

export enum WorkflowStatus {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  ERRORED = "ERRORED",
  NOT_RUN = "NOT_RUN",
}

export enum WorkflowType {
  SUBDOMAIN_SCAN = "SUBDOMAIN_SCAN",
  VULNERABILITY_SCAN = "VULNERABILITY_SCAN",
}

export interface WorkflowList {
  pagination?: PaginationResponse;
  rows?: Workflow[];
}

export interface Task {
  /**
   * The ID of the task.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The title of the task. */
  title: string;
  /** The description of the task. */
  description: string;
  /**
   * The time that this task was completed.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this task was completed.
   * @format date-time
   */
  completedAt?: string;
  tags: string[];
  /** The tenant associated with this task. */
  tenant?: Tenant;
  /**
   * The ID of the tenant associated with this task.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The type of task. */
  type: TaskType;
  data?: PolymorphNull &
    (
      | PolymorphNullTypeMapping<"FAILING_MONITOR", FailingMonitorData>
      | PolymorphNullTypeMapping<"UNREMEDIATED_FINDING", UnremediatedFindingData>
      | PolymorphNullTypeMapping<"FAILING_POLICY", FailingPolicyData>
    );
}

export interface TaskList {
  pagination?: PaginationResponse;
  rows?: Task[];
}

export enum TaskType {
  FAILING_MONITOR = "FAILING_MONITOR",
  FAILING_POLICY = "FAILING_POLICY",
  UNREMEDIATED_FINDING = "UNREMEDIATED_FINDING",
}

export interface FailingMonitorData {
  type: string;
  /**
   * The date that this task is due.
   * @format date-time
   */
  dueDate?: string;
  /** The monitor associated with this task. */
  monitor: Monitor;
}

export interface UnremediatedFindingData {
  type: string;
  /** The finding associated with this task. */
  findings?: Finding;
  /**
   * The date that this task is due.
   * @format date-time
   */
  dueDate?: string;
}

export interface FailingPolicyData {
  type: string;
  /**
   * The date that this task is due.
   * @format date-time
   */
  dueDate?: string;
  /** The policy version associated with this task. */
  policyVersion: PolicyVersion;
}

export interface SlackSettings {
  /**
   * The time that this report was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this report was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The channel that notifications are sent to. */
  channel?: SlackChannel;
}

export interface SlackChannel {
  /** The ID of the Slack channel. */
  id: string;
  /** The URL of the Slack channel. */
  url: string;
  /** The workspace of the Slack channel. */
  workspace: string;
  /** The name of the Slack channel. */
  name: string;
  /** Whether the Slack channel is private. */
  isPrivate: boolean;
}

export type SlackChannelList = SlackChannel[];

export interface UpdateSlackSettingsRequest {
  /** The ID of the Slack channel. */
  channelId?: string;
}

export interface Exception {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  monitorId?: string;
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  endedAt?: string;
  monitor?: Monitor;
  policy?: Policy;
  notes?: string;
  hidden?: boolean;
}

/** A list of exceptions with dependencies. */
export type ExceptionList = Exception[];

/** The notes to update. */
export interface UpdateExceptionNotes {
  notes: string;
}

/** The visibility to update. */
export interface UpdateExceptionVisibility {
  hidden: boolean;
}

export enum DeviceType {
  MACOS = "MACOS",
  LINUX = "LINUX",
  WINDOWS = "WINDOWS",
}

export interface Device {
  /**
   * The ID of the device.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this device was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this device was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the tenant.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /**
   * The ID of the tenant member.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantMemberId?: string;
  /** The type of the device. */
  type: DeviceType;
  /** The unique identifier for the device. */
  uniqueId: string;
  /** The name of the device. */
  name: string;
  /**
   * The time that this device last pinged.
   * @format date-time
   */
  lastPing?: string;
  /** Whether the device has an active session. */
  hasActiveSession?: boolean;
  tenantMember?: TenantMember;
  /** The version of the Oneleet Agent installed on the device. */
  agentVersion?: string;
  /** Whether the device is enrolled with the Oneleet MDM servers. */
  isEnrolledInMdm: boolean;
  /** Whether the device is a virtual machine. */
  isVirtualMachine?: boolean;
}

export interface DeviceList {
  pagination?: PaginationResponse;
  rows?: Device[];
}

export interface DeviceInfo {
  serial: string;
  hardwareName: string;
  type: DeviceType;
  osVersion: string;
  osBuild: string;
  hardwareSpecs?: string;
  isVirtualMachine: boolean;
  isOnline: boolean;
  /** @format int64 */
  uptimeSeconds?: number;
}

export interface AgentInfo {
  /** @format date-time */
  lastPing?: string;
  /** @format date-time */
  firstSeenAt: string;
  agentVersion?: string;
  isLatestVersion?: boolean;
}

export interface TenantDevice {
  /** @format uuid */
  id: string;
  name: string;
  owner?: TenantMember;
  isInScope: boolean;
  isArchived: boolean;
  deviceInfo: DeviceInfo;
  agentInfo: AgentInfo;
  issueCount?: number;
  monitors?: DeviceMonitor[];
  apps?: object[];
  status: DeviceStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TenantDeviceList {
  pagination?: PaginationResponse;
  rows?: TenantDevice[];
}

export enum DeviceStatus {
  NON_COMPLIANT = "NON_COMPLIANT",
  COMPLIANT = "COMPLIANT",
  PENDING = "PENDING",
  UNASSIGNED = "UNASSIGNED",
  OUT_OF_SCOPE = "OUT_OF_SCOPE",
  ARCHIVED = "ARCHIVED",
}

export interface DeviceMonitor {
  /**
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** The monitor associated with this device. */
  monitor: Monitor;
  /** The asset result for this device. */
  assetResult?: MonitorAssetResult;
  /** The status of the monitor for this device. */
  status: MonitorStatus;
}

export interface DeviceLoginRequest {
  /** The pre-enrollment token of the device. */
  preEnrollmentToken: string;
  /** The Auth0 access token for the device. */
  accessToken: string;
  /** The Auth0 refresh token for the device. */
  refreshToken: string;
  /** The Auth0 ID token for the device. */
  idToken: string;
  /**
   * The time that the Auth0 tokens expire.
   * @format date-time
   */
  expiresAt: string;
}

export interface DeviceLoginResponse {
  /** The email of the authenticated user. */
  email: string;
  /** The auth token for the device. */
  token: string;
}

export interface UpdateTenantDeviceRequest {
  /** The name of the device. */
  name?: string;
  /** Whether the device is in scope. */
  isInScope?: boolean;
  /** Whether the device is archived. */
  isArchived?: boolean;
  /** Unassign the device. */
  unassign?: boolean;
}

export interface TenantEmployeeCreateRequest {
  /**
   * The email of the tenant employee.
   * @format email
   * @maxLength 2000
   */
  email: string;
  /**
   * The name of the tenant employee.
   * @maxLength 256
   */
  name: string;
  /** The type of the tenant employee. */
  type: TenantMemberType;
  /** The group ids to add the tenant employee to. */
  groupIds?: string[];
}

export interface PreEnrollAgentDeviceRequest {
  /** The name of the device. */
  name: string;
  /** The unique identifier for the device. */
  deviceUid: string;
  /** The system that the device is running. */
  type: DeviceType;
  /** The ID of the tenant. */
  tenantId?: string;
}

export interface PreEnrollAgentDeviceResponse {
  /**
   * The pre-enroll token for the device.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  token: string;
}

export interface AgentDeviceStatusResponse {
  /** The email address of the user. */
  email?: string;
  blacklisted: boolean;
  /**
   * The date and time when the device session expires.
   * @format date-time
   */
  expiresAt: string;
  /** The link to the Apple MDM profile, if enabled by the tenant. */
  appleMdmProfileUrl?: string;
  requiredMonitorTypes: string[];
}

export interface AgentDeviceUpdateRequest {
  name: string;
  data: object;
}

export interface AgentDeviceDataResponse {
  deviceMonitors: DeviceMonitor[];
}

export type AppleMDMCommandRequest = BaseAppleMdmCommandRequest &
  (
    | BaseAppleMdmCommandRequestCommandMapping<"restart", AppleMDMRestartCommand>
    | BaseAppleMdmCommandRequestCommandMapping<"shutdown", AppleMDMShutdownCommand>
  );

export interface AppleMDMWipeCommand {
  /** The command to issue to the device. */
  command: "wipe";
  /** The passcode to unlock the device. */
  passcode: string;
}

export interface AppleMDMLockCommand {
  /** The command to issue to the device. */
  command: "lock";
  /** The passcode to unlock the device. */
  passcode: string;
}

export interface AppleMDMRestartCommand {
  /** The command to issue to the device. */
  command: "restart";
}

export interface AppleMDMShutdownCommand {
  /** The command to issue to the device. */
  command: "shutdown";
}

export interface AppleMDMSettings {
  /** The legal name of the tenant. */
  tenantLegalName?: string;
  /** The country of the tenant. */
  country?: string;
  /** The email address of the tenant. */
  email?: string;
  /**
   * The expiry date of the push certificate.
   * @format date-time
   */
  pushCertExpiry?: string;
  /** The push certificate topic. */
  pushCertTopic?: string;
}

export interface AppleMDMGenCSRRequest {
  /** The legal name of the tenant. */
  tenantLegalName: string;
  /** The country of the tenant. */
  country: string;
  /** The email address of the tenant. */
  email: string;
}

export interface UpsertAppleMDMDeviceRequest {
  /** The serial name of the device. */
  serialName: string;
  /** The push topic of the device. */
  pushTopic: string;
  /** The name of the device. */
  deviceName: string;
}

export interface UnenrollAppleMDMDeviceRequest {
  /** The serial name of the device. */
  serialName: string;
  /** The push topic of the device. */
  pushTopic: string;
}

/** A Git Repository */
export interface GitRepository {
  /** The id of the repository */
  id: string;
  /** The tenant id */
  tenantId: string;
  /** The connection id of the repository */
  connectionId?: string;
  /** The organization name of the repository */
  ownerName: string;
  /** The repository name of the repository */
  name: string;
  /** The provider of the repository */
  provider: GitRepositoryProvider;
  /** The target branch of the repository */
  targetBranch: string;
  /** Whether or not code health scans are enabled for this repository */
  isScanningEnabled: boolean;
  /** Whether or not to capture snippets from the codebase on scan */
  isSnippetCaptureEnabled: boolean;
  /**
   * The time the repository was deleted.
   * @format date-time
   */
  deletedAt?: string;
  /** List of ignore files present in the repository */
  ignoreFiles?: {
    /** The path of the ignore file relative to the repository root */
    path: string;
    /** The type of ignore file */
    type: string;
  }[];
}

/** The provider of the repository */
export enum GitRepositoryProvider {
  GITHUB = "GITHUB",
  GITLAB = "GITLAB",
}

/** A list of Git Repositories */
export type GitRepositoryList = GitRepository[];

/** The Git Repository to create */
export interface GitRepositoryCreate {
  /** The connection id of the repository */
  connectionId: string;
  /** The organization name of the repository */
  ownerName: string;
  /** The repository name of the repository */
  name: string;
  /** The target branch of the repository */
  targetBranch: string;
  /** Whether or not to capture snippets from the codebase on scan */
  isSnippetCaptureEnabled: boolean;
}

/** The Git Repository to update */
export interface GitRepositoryUpdate {
  /** The target branch of the repository */
  targetBranch?: string;
  /** Whether or not the scans are disabled for this repository */
  isScanningEnabled?: boolean;
  /** Whether or not to capture snippets from the codebase on scan */
  isSnippetCaptureEnabled?: boolean;
}

/** A Git Repository Branch */
export interface GitRepositoryBranch {
  /** The name of the branch */
  name: string;
  /** Whether this is the default branch */
  isDefault: boolean;
  /**
   * The timestamp of the last commit on this branch
   * @format date-time
   */
  lastCommitTime?: string;
}

/** A list of Git Repository Branches */
export interface GitRepositoryBranchList {
  /** List of branches */
  branches: GitRepositoryBranch[];
}

export interface CodeHealthOverview {
  /** The number of issues associated with this code health overview. */
  issuesCount: number;
  /** The issues per repository associated with this code health overview. */
  issuesPerRepository: RepositoryIssues[];
}

export interface RepositoryIssues {
  /**
   * The ID of the repository.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  repositoryId: string;
  /** The number of issues associated with this repository. */
  issuesCount: number;
  /** The name of the owner of the repository. */
  repositoryOwnerName?: string;
  /** The name of the repository. */
  repositoryName: string;
}

/**
 * Scan result is a representation of the results of a code health scan.
 * These are going to be parsed and stored in the database.
 */
export interface ScanResult {
  /** The unique identifier of the scan result */
  uniqueId: string;
  /**
   * The severity of the scan result. This is used to determine the impact of the
   * scan result on the code health.
   */
  severity: ScanResultSeverity;
  /** The title of the issue that was found */
  issueTitle: string;
  /** The type of issue that was found */
  issueTypeId: string;
  /** The title of the issue that was found */
  issueTypeTitle: string;
  /** The file path of the issue that was found */
  filePath: string;
  /** The line number where the issue starts */
  startLine?: number;
  /** The line number where the issue ends */
  endLine?: number;
  /** The code snippet of the issue that was found */
  codeSnippet?: string;
  /**
   * The id of the git repository that the scan result is associated with
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  gitRepositoryId: string;
  /** The branch name of the git repository that the scan result is associated with */
  gitBranchName: string;
  /** The scanner that produced the scan result */
  scanner: string;
}

/**
 * The severity of the scan result. This is used to determine the impact of the
 * scan result on the code health.
 */
export enum ScanResultSeverity {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  INFO = "INFO",
}

/** A list of scan results that are going to be ingested into the database. */
export interface ScanResultList {
  /**
   * The tenant id of the scan results
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId?: string;
  /**
   * The git repository id of the scan results
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  gitRepositoryId?: string;
  /** The branch name of the git repository that the scan results are associated with */
  gitBranchName?: string;
  /** The list of scan results */
  scanResults?: ScanResult[];
}

export interface CodeSecurityScanUploadRequest {
  /** SARIF-formatted scan results as a JSON document */
  sarifLog: string;
  /** Scan memo as a JSON document (helps reconcile subsequent scans with this scan) */
  memo?: string;
}

export interface CodeSecuritySettings {
  codeSecuritySensitivity?: CodeSecurityIssueConfidence | null;
}

export interface UpdateCodeSecuritySettingsRequest {
  codeSecuritySensitivity: CodeSecurityIssueConfidence;
}

export interface CodeSecurityFindingLocation {
  /**
   * The unique identifier of the location.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the location was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the location was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** A Git Repository */
  gitRepository: GitRepository;
  /** The name of the branch where the finding was found. */
  branchName: string;
  /** The hash of the commit where the finding was found. */
  commitHash: string;
  /** The path of the file where the finding was found. */
  filePath: string;
  /** The start line of the finding. */
  startLine: number;
  /** The end line of the finding. */
  endLine: number;
}

export enum CodeSecurityIssueConfidence {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export enum CodeSecurityIssueSeverity {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  INFO = "INFO",
}

export enum CodeSecurityFindingStatus {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  RESOLVED = "RESOLVED",
  SUPPRESSED = "SUPPRESSED",
}

export enum CodeSecurityFindingResolution {
  FIXED = "FIXED",
  FALSE_POSITIVE = "FALSE_POSITIVE",
  ACCEPTED_RISK = "ACCEPTED_RISK",
  MITIGATED = "MITIGATED",
  REMOVED = "REMOVED",
}

export interface Vendor {
  /** The unique identifier of the vendor. */
  id: string;
  /** The name of the vendor. */
  name: string;
  /** The category of the vendor. */
  category?: string;
  /** The URL of the vendor. */
  url?: string;
  /** The icon URL of the vendor. */
  icon?: string;
  /** Whether the vendor is verified. */
  verified: boolean;
  integrationType?: IntegrationType;
  complianceData?: VendorComplianceData[];
  /** The vendor's pre-defined risk assessment template. */
  assessmentTemplate?: object;
}

export interface VendorList {
  pagination?: PaginationResponse;
  rows: Vendor[];
}

export interface UpsertVendor {
  /** The unique identifier of the vendor. */
  id: string;
  /** The name of the vendor. */
  name: string;
  /** The URL of the vendor. */
  url: string;
  /** The integration type ID of the vendor. */
  integrationTypeId?: string;
  /** The icon URL of the vendor. */
  icon?: string;
  /** Compliance frameworks the vendor uses. */
  complianceData?: VendorComplianceData[];
  /** The vendor's pre-defined risk assessment template. */
  assessmentTemplate?: object;
}

export interface DeleteVendor {
  /** The unique identifier of the vendor. */
  id?: string;
}

export interface UploadVendorLogoRequest {
  /**
   * Supported types are image/png, image/jpeg, image/webp
   * @format binary
   */
  upload?: File;
}

export interface CreateUpdateTenantVendorData {
  /** The vendor ID. */
  vendorId: string;
  /** The tenant vendor discovery ID. */
  tenantVendorDiscoveryId?: string;
  /** The assessed risk of the tenant vendor. */
  risk?: TenantVendorRisk;
  /** JSON array of categorized risk assessment data for the tenant vendor. */
  data?: object[] | object;
  /** The operation to perform. */
  operation: "create_update";
  /** Whether the vendor data is completely filled. */
  isCompleted: boolean;
  /** An array of services this vendor provides */
  services?: string[];
  /** An array of countries in which this vendor processes personal data */
  processingLocations?: string[];
  /** If true, indicates this vendor processes personally identifiable information. */
  processesPii?: boolean;
  /** URL of the vendor's website. */
  vendorUrl?: string;
  /** The notes for the tenant vendor. */
  notes?: string;
  /** The ID of the member assigned to this vendor. */
  assignedToMemberId?: string;
}

export interface CreateCustomVendorData {
  /** The name of the custom vendor. */
  name: string;
  /** The icon URL of the custom vendor. */
  icon?: string;
  /** The URL of the custom vendor. */
  url?: string;
  /** The risk of the tenant vendor. */
  risk?: ClassificationRisk;
  /** JSON array of categorized risk assessment data for the tenant vendor. */
  data?: object[] | object;
  /** The operation to perform. */
  operation: "create_custom";
  /** Whether the vendor data is completely filled. */
  isCompleted: boolean;
  /** The notes for the custom vendor. */
  notes?: string;
}

export type CreateUpdateTenantVendor = BaseCreateUpdateTenantVendor &
  (
    | BaseCreateUpdateTenantVendorOperationMapping<"create_update", CreateUpdateTenantVendorData>
    | BaseCreateUpdateTenantVendorOperationMapping<"create_custom", CreateCustomVendorData>
  );

export interface TenantVendor {
  /**
   * The unique identifier of the tenant vendor.
   * @format uuid
   */
  id: string;
  vendor: Vendor;
  tenantVendorDiscovery?: TenantVendorDiscovery;
  /** The assessed risk of the tenant vendor. */
  risk: TenantVendorRisk;
  /** JSON array of categorized risk assessment data for the tenant vendor. */
  data?: object[] | object;
  /** Evidence documents and files associated with this vendor. */
  evidence?: Evidence[];
  /** Whether the vendor data is completely filled. */
  isCompleted: boolean;
  /** An array of services this vendor provides */
  services?: string[];
  /** An array of countries in which this vendor processes personal data */
  processingLocations?: string[];
  /** If true, indicates this vendor processes personally identifiable information. */
  processesPii?: boolean;
  /** URL of the vendor's website. */
  vendorUrl?: string;
  /** The notes for the tenant vendor. */
  notes?: string;
  /** The external accounts linked to the vendor. */
  externalAccounts?: ExternalAccountBase[];
  /** The member assigned to this vendor. */
  assignedToMember?: TenantMember;
}

export enum TenantVendorRisk {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export interface TenantVendorList {
  pagination?: PaginationResponse;
  rows: TenantVendor[];
}

export interface TenantVendorDiscovery {
  /** The unique identifier of the discovery. */
  id: string;
  /** The identifier for the associated vendor. */
  vendorId: string;
  vendor?: Vendor;
  /** The unique identifier of the integration which created this record. */
  integrationId: string;
  /** The unique identifier of the tenant which created this record. */
  tenantId: string;
  /** The custom vendor id even if a custom vendor wasn't made. */
  originalVendorId: string;
  /** The name of the vendor. */
  originalName: string;
  /** The URL of the vendor. */
  originalUrl?: string;
  /** The icon URL of the vendor. */
  originalIcon?: string;
  /** The category of the vendor. */
  category?: string;
  /** The OAuth accounts detected from the vendor. */
  oauthAccounts?: string[];
  /** The external accounts linked to the vendor. */
  externalAccounts?: ExternalAccountBase[];
}

export interface TenantVendorDiscoveryList {
  pagination?: PaginationResponse;
  discoveries: TenantVendorDiscovery[];
  integrationTypes: IntegrationType[];
}

export interface TenantVendorDiscoveryDeletedCount {
  /** The number of deleted vendor discoveries. */
  count: number;
}

export interface TenantVendorDiscoveryWorkflowRun {
  /** The unique identifier of the workflow run. */
  id: string;
  /** The unique identifier of the tenant. */
  tenantId: string;
}

export interface VendorComplianceData {
  /** The compliance framework ID */
  id: string;
  /** The name of the compliance framework */
  name: string;
  /** The URL of the vendor's compliance data */
  url: string;
  /** The URL to request the compliance report from the vendor */
  reportUrl?: string;
}

export type ExternalAccount = ExternalAccountBase & {
  tenantMember?: TenantMember;
  suggestedTenantMember?: TenantMember;
};

export interface ExternalAccountBase {
  /**
   * The ID of the external account.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The time that this external account was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this external account was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The ID of the tenant this external account belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  /** The name of the workspace in the external system that the account belongs to. */
  workspaceName?: string;
  /**
   * The ID of the vendor this external account belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantVendorId?: string;
  tenantVendor?: TenantVendor;
  /**
   * The ID of the member this account belongs to, if null the account has not been linked to any member yet.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantMemberId?: string;
  /** Whether the account is active or not. */
  isActive: boolean;
  /** Whether the account has been ignored or not. */
  isIgnored: boolean;
  /**
   * The ID of a suggested member this account belongs to, if null no suspected member has been guessed by account discovery.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  suggestedTenantMemberId?: string;
  /**
   * The ID of the asset this external account belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  assetId?: string;
  asset?: Asset;
  /**
   * The ID of the connection this external account belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  connectionId?: string;
  connection?: Connection;
  /** The username of the user for this external account. */
  username?: string;
  /** The name of the user for this external account. */
  name?: string;
  /** The email of the user for this external account. */
  email?: string;
  /** The profile image URL of the user for this external account. */
  image?: string;
  /** The roles of the user for this external account. */
  roles?: string[];
  /** Whether the user is enabled for MFA. */
  isMfaEnabled?: boolean;
}

export interface ExternalAccountList {
  pagination?: PaginationResponse;
  rows?: ExternalAccount[];
}

export interface ExternalAccountUpdateRequest {
  /** The ID of a member to link this account to, or an empty string to unlink the account. */
  tenantMemberId?: string;
  /** Whether the account is active or not. */
  isActive?: boolean;
  /** Whether the account should be ignored or not. */
  isIgnored?: boolean;
  /** The name of the workspace in the external system that the account belongs to. */
  workspaceName?: string;
  /** The roles of the account. */
  roles?: string[];
  /** Whether the account is enabled for MFA. */
  isMfaEnabled?: boolean;
}

export interface Risk {
  /**
   * The ID of the risk.
   * @format uuid
   */
  id: string;
  /**
   * The time that this risk was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this risk was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The time that this risk was assessed.
   * @format date-time
   */
  assessedAt?: string;
  /**
   * The time that this risk was archived.
   * @format date-time
   */
  archivedAt?: string;
  /** The title of the risk. */
  title: string;
  /** The description of the risk. */
  description?: string;
  /** The category of the risk. */
  category: RiskCategory;
  /** The impact of the risk. */
  impact?: RiskImpact;
  /** The likelihood of the risk. */
  likelihood?: RiskLikelihood;
  rating?: RiskRating;
  /** The response to the risk. */
  response?: RiskResponse;
  /** The details of the risk response. */
  responseDetails?: string;
  /** Whether the risk has a residual risk. */
  hasResidualRisk?: boolean;
  /** The residual impact of the risk. */
  residualImpact?: RiskImpact;
  /** The residual likelihood of the risk. */
  residualLikelihood?: RiskLikelihood;
  residualRating?: RiskRating;
  /** Additional notes or comments about the risk. */
  note?: string;
  /**
   * The ID of the tenant associated with this risk.
   * @format uuid
   */
  tenantId: string;
  /**
   * The ID of the risk assessment associated with this risk.
   * @format uuid
   */
  riskAssessmentId: string;
  riskAssessment?: RiskAssessment;
  /**
   * The ID of the previous risk associated with this risk.
   * @format uuid
   */
  previousRiskId?: string;
  /**
   * The ID of the owner associated with this risk.
   * @format uuid
   */
  ownerId?: string;
  owner?: TenantMember;
  controls?: Control[];
}

export enum RiskCategory {
  SECURITY = "SECURITY",
  OPERATIONAL = "OPERATIONAL",
  FINANCIAL = "FINANCIAL",
  LEGAL_AND_COMPLIANCE = "LEGAL_AND_COMPLIANCE",
  STRATEGIC_AND_MARKET = "STRATEGIC_AND_MARKET",
  FRAUD = "FRAUD",
}

export enum RiskImpact {
  MINOR = "MINOR",
  MODERATE = "MODERATE",
  MAJOR = "MAJOR",
}

export enum RiskLikelihood {
  UNLIKELY = "UNLIKELY",
  LIKELY = "LIKELY",
  VERY_LIKELY = "VERY_LIKELY",
}

export enum RiskRating {
  NONE = "NONE",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum RiskResponse {
  MITIGATE = "MITIGATE",
  TRANSFER = "TRANSFER",
  AVOID = "AVOID",
  ACCEPT = "ACCEPT",
}

export interface RiskAssessment {
  /**
   * The ID of the risk assessment.
   * @format uuid
   */
  id: string;
  /**
   * The ID of the tenant associated with this risk assessment.
   * @format uuid
   */
  tenantId: string;
  /** The title of the risk assessment. */
  title: string;
  risks?: Risk[];
  /**
   * The time that this risk assessment was completed.
   * @format date-time
   */
  completedAt?: string;
  /**
   * The time that this risk assessment was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this risk assessment was last updated.
   * @format date-time
   */
  updatedAt: string;
}

export interface CreateRiskRequest {
  /** The title of the risk. */
  title: string;
  /** The description of the risk. */
  description?: string;
  category: RiskCategory;
  /** The ID of the owner associated with this risk. */
  ownerId?: string;
}

export interface CreateRiskAssessmentRequest {
  title: string;
}

export interface UpdateRiskRequest {
  /** The title of the risk. */
  title?: string;
  /** The description of the risk. */
  description?: string;
  category?: RiskCategory;
  impact?: RiskImpact;
  likelihood?: RiskLikelihood;
  response?: RiskResponse;
  /** The details of the risk response. */
  responseDetails?: string;
  /** Whether the risk has a residual risk. */
  hasResidualRisk?: boolean;
  residualImpact?: RiskImpact;
  residualLikelihood?: RiskLikelihood;
  /** The ID of the owner associated with this risk. */
  ownerId?: string;
  controls?: {
    /**
     * The ID of the control to link to the risk.
     * @format uuid
     */
    controlId: string;
    /** True if the control is linked to the risk, false if it is unlinked. */
    link: boolean;
  }[];
  /** Additional notes or comments about the risk. */
  note?: string;
  /** An object containing any fields that should be cleared. */
  clear?: {
    /** If true, clears the impact value. */
    impact?: boolean;
    /** If true, clears the likelihood value. */
    likelihood?: boolean;
    /** If true, clears the response value. */
    response?: boolean;
    /** If true, clears the has residual risk value. */
    hasResidualRisk?: boolean;
    /** If true, clears the residual impact value. */
    residualImpact?: boolean;
    /** If true, clears the residual likelihood value. */
    residualLikelihood?: boolean;
    /** If true, clears the note value. */
    note?: boolean;
  };
}

export interface UpdateRiskAssessmentRequest {
  title?: string;
  /**
   * The time that this risk assessment was completed.
   * @format date-time
   */
  completedAt?: string;
  /** An object containing any fields that should be cleared. */
  clear?: {
    /** If true, clears the completedAt value to reopen the assessment. */
    completedAt?: boolean;
  };
}

export interface AuditType {
  /** The ID of the audit type. */
  id: string;
  /**
   * The time that this audit type was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The title of the audit type. */
  name: string;
  stages: AuditStage[];
}

/** The stage of the audit. */
export enum AuditStage {
  PREPARATION = "PREPARATION",
  SCOPE_IDENTIFICATION = "SCOPE_IDENTIFICATION",
  MAINTENANCE_AND_IMPROVEMENT = "MAINTENANCE_AND_IMPROVEMENT",
  OBSERVATION_PERIOD = "OBSERVATION_PERIOD",
  INTERNAL_AUDIT = "INTERNAL_AUDIT",
  STAGE1AUDIT = "STAGE_1_AUDIT",
  STAGE2AUDIT = "STAGE_2_AUDIT",
  AUDIT = "AUDIT",
  REPORT_READY = "REPORT_READY",
}

export interface Audit {
  /**
   * The ID of the audit.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The ID of the tenant.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  tenantId: string;
  auditType: AuditType;
  /**
   * The ID of the framework.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  frameworkId: string;
  /** The version of the audit. */
  version: number;
  /**
   * The time that this audit was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The time that this audit was last updated.
   * @format date-time
   */
  updatedAt?: string;
  /**
   * The start of the observation period.
   * @format date-time
   */
  observationPeriodStart?: string;
  /**
   * The end of the observation period.
   * @format date-time
   */
  observationPeriodEnd?: string;
  /** The name of the report. */
  reportFileName?: string;
  /** The URL of the report. */
  reportUrl?: string;
  /** The stage of the audit. */
  currentStage: AuditStage;
}

export interface CreateAuditPayload {
  /** The ID of the audit type. */
  auditTypeId: string;
}

export interface UpdateAuditStagePayload {
  /** The stage of the audit. */
  stage: AuditStage;
}

export interface UploadAuditReportPayload {
  /**
   * Supported types application/pdf
   * @format binary
   */
  reportFile?: File;
}

export interface UpdateAuditObservationPeriodPayload {
  /**
   * The start of the observation period.
   * @format date-time
   */
  observationPeriodStartAt: string;
  /**
   * The end of the observation period
   * @format date-time
   */
  observationPeriodEndAt: string;
}

export interface Auth0RevokeSessionsRequest {
  /**
   * The email of the user.
   * @format email
   */
  email: string;
}

export interface Auth0UserInfoResponse {
  /** The email of the user. */
  email: string;
  /** Whether the user should require MFA. */
  requires_mfa: boolean;
}

export interface CodeHealthIssue {
  /**
   * The unique identifier of the issue.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /** A unique identifier for the issue produced by the scanner. */
  uniqueId: string;
  /**
   * The date and time the issue was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the issue was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The title of the issue. */
  title: string;
  /** The path to the file where the issue was found. */
  filePath: string;
  /** The line number where the issue starts. */
  startLine: number;
  /** The line number where the issue ends. */
  endLine: number;
  /** The git branch where the issue was found. */
  gitBranch: string;
  finding: Finding;
  /** A Git Repository */
  gitRepository: GitRepository;
  issueType: CodeHealthIssueType;
  /** The code snippet where the issue was found. */
  codeSnippet?: string;
}

export interface CodeHealthIssueType {
  /** The unique identifier of the issue type. */
  id: string;
  /**
   * The date and time the issue type was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the issue type was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The title of the issue type. */
  title: string;
  /** The description of the issue type. */
  description?: string;
}

export interface CodeHealthIgnoreRule {
  /**
   * The unique identifier of the ignore rule.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the ignore rule was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the ignore rule was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The description of the ignore rule. */
  description?: string;
  /** Whether the ignore rule is enabled. */
  isEnabled: boolean;
  /** Whether the ignore rule is managed by Oneleet. */
  isOneleetManaged: boolean;
  /** The list of repositories the ignore rule applies to. */
  repositories: string[];
  issueType: CodeHealthIssueType;
}

export interface UpdateCodeHealthIssueBody {
  /** The status of the issue. */
  status: "OPEN" | "FALSE_POSITIVE" | "IGNORED";
  /**
   * The reason for the status change.
   * @maxLength 6000
   */
  reason?: string;
}

export interface CreateCodeHealthIgnoreRuleBody {
  /**
   * The description of the ignore rule.
   * @maxLength 6000
   */
  description?: string;
  /** The unique identifier of the issue type. */
  issueTypeId: string;
  /** The list of repositories the ignore rule applies to. */
  repositories?: string[];
}

export interface UpdateCodeHealthIssueTypeBody {
  /**
   * The title of the issue type.
   * @minLength 1
   * @maxLength 255
   */
  title?: string;
  /**
   * The description of the issue type.
   * @maxLength 600
   */
  description?: string;
}

export interface UpdateCodeHealthIgnoreRuleBody {
  /**
   * The description of the ignore rule.
   * @maxLength 6000
   */
  description?: string;
  /** Whether the ignore rule is enabled. */
  isEnabled?: boolean;
  /** The list of repository ids the ignore rule applies to. */
  repositories?: string[];
}

export interface BulkUpdateCodeHealthIssueBody {
  /** The list of issue ids to update. */
  issueIds: string[];
  /** The status of the issue. */
  status: "OPEN" | "FALSE_POSITIVE" | "IGNORED";
}

export interface ScanInfo {
  /** The unique identifier of the repository. */
  repositoryId: string;
  /**
   * The date and time the scan was last run.
   * @format date-time
   */
  lastRun?: string;
  /**
   * The date and time the scan is scheduled to run next.
   * @format date-time
   */
  nextRun?: string;
  /** Whether the scan is currently running. */
  isScanning: boolean;
  /** Whether the scan has been run before. */
  isFirstRun?: boolean | null;
}

export type ScanInfoList = ScanInfo[];

export interface CodeSecurityIssue {
  /**
   * The unique identifier of the issue.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the issue was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the issue was last updated.
   * @format date-time
   */
  updatedAt: string;
  toolName: string;
  toolAssignedId: string;
  /** The title of the issue. */
  title: string;
  /** Link to documentation page for the issue. */
  helpUrl?: string | null;
  severity: CodeSecurityIssueSeverity;
  confidence: CodeSecurityIssueConfidence;
  findings: CodeSecurityFinding[];
  /** Whether the issue is ignored. */
  ignored: boolean;
  /** The reason the issue is ignored. */
  ignoreReason?: string | null;
  ignoredBy?: TenantMember | null;
  ignoredById?: string | null;
}

export type CodeSecurityIssueList = CodeSecurityIssue[];

export interface CodeSecurityFinding {
  /**
   * The unique identifier of the finding.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the finding was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the finding was last updated.
   * @format date-time
   */
  updatedAt: string;
  issue: CodeSecurityIssue;
  /** The title of the finding. */
  title: string;
  currentLocation: CodeSecurityFindingLocation;
  /** The code snippet of the finding. */
  codeSnippet?: string | null;
  status: CodeSecurityFindingStatus;
  resolution?: CodeSecurityFindingResolution | null;
  /** User-specified description of how the finding was resolved. */
  resolutionDescription?: string | null;
  /**
   * Time when the finding was first marked as resolved.
   * @format date-time
   */
  resolvedAt?: string | null;
  resolvedBy?: TenantMember | null;
  owner?: TenantMember | null;
  /** Whether the finding was suppressed. */
  suppressed: boolean;
  /** User-specified description of why the finding was suppressed. */
  suppressedReason?: string | null;
}

export type CodeSecurityFindingList = CodeSecurityFinding[];

export interface UpdateCodeSecurityFindingBody {
  /**
   * The ID of the tenant member to assign as the owner of the findings.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ownerId?: string;
  /** The resolution status for the findings. */
  resolution?: CodeSecurityFindingResolution;
  /**
   * User-specified description of how the findings were resolved.
   * @maxLength 6000
   */
  resolutionDescription?: string;
  /** Fields to clear/unset. */
  clear?: {
    /** Set to true to clear the owner assignment. */
    ownerId?: boolean;
    /** Set to true to clear the resolution status. */
    resolution?: boolean;
  };
}

export interface CodeSecurityScanInfo {
  /**
   * The unique identifier of the scan info.
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the scan info was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the scan info was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The date and time the scan was last run.
   * @format date-time
   */
  lastRun?: string;
  /**
   * The date and time the scan is scheduled to run next.
   * @format date-time
   */
  nextRun?: string;
  /** Whether the scan is currently running. */
  isScanning: boolean;
  /** Whether the scan has been run before. */
  isFirstRun?: boolean | null;
  /** Error message from the last failed scan (null when scan succeeds or hasn't failed). */
  lastScanFailedErrorMessage?: string | null;
}

export type CodeSecurityScanInfoList = CodeSecurityScanInfo[];

export interface CodeSecurityScanRun {
  /**
   * The unique identifier of the scan run.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the scan run was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the scan run was last updated.
   * @format date-time
   */
  updatedAt: string;
  /**
   * The date and time the scan completed successfully.
   * @format date-time
   */
  completedAt?: string | null;
  /**
   * Whether a scan is currently running for this repository.
   * @default false
   */
  isScanning: boolean;
  /**
   * Whether this is the first scan for the repository.
   * @default true
   */
  isFirstRun: boolean;
  /** Error message from the last failed scan (null when scan succeeds or hasn't failed). */
  lastScanFailedErrorMessage?: string | null;
  /**
   * The ID of the git repository this scan run belongs to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  gitRepositoryId: string;
}

export type CodeSecurityScanRunList = CodeSecurityScanRun[];

export interface CodeSecurityIgnoreRule {
  /**
   * The unique identifier of the ignore rule.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  id: string;
  /**
   * The date and time the ignore rule was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the ignore rule was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The IDs of the git repositories this ignore rule applies to. */
  gitRepositoryIds: string[];
  /**
   * The ID of the code security issue this ignore rule applies to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  issueId: string;
  /** The reason for ignoring this issue. */
  reason?: string | null;
  /** The tenant member who created this ignore rule. */
  ignoredBy?: TenantMember | null;
  /**
   * The ID of the tenant member who created this ignore rule.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  ignoredById?: string | null;
  /** Whether the ignore rule is enabled. */
  isEnabled: boolean;
}

export type CodeSecurityIgnoreRuleList = CodeSecurityIgnoreRule[];

export interface CreateCodeSecurityIgnoreRuleBody {
  /**
   * The IDs of the git repositories this ignore rule applies to.
   * @minItems 1
   */
  gitRepositoryIds: string[];
  /**
   * The ID of the code security issue this ignore rule applies to.
   * @format uuid
   * @minLength 36
   * @maxLength 36
   */
  issueId: string;
  /** The reason for ignoring this issue. */
  reason?: string | null;
}

export interface UpdateCodeSecurityIgnoreRuleBody {
  /**
   * The IDs of the git repositories this ignore rule applies to. This will replace the existing list of repositories.
   * @minItems 1
   */
  gitRepositoryIds?: string[];
  /** The reason for ignoring this issue. */
  reason?: string | null;
  /** Whether the ignore rule is enabled. */
  isEnabled?: boolean;
}

export interface AttackSurfaceAsset {
  /** The internal ID of the asset */
  id: string;
  /** The type of the asset */
  type: AttackSurfaceAssetType;
  /** The name of the asset */
  name: string;
  /** The URL of the asset, this is optional as there are assets that do not have a URL */
  url?: string;
  /** The parent id of the asset, this is never empty, instead we use the tenant id as the parent of the root asset */
  parentId?: string;
  /** Whether the asset is a target or not */
  isTarget: boolean;
  /** Whether the asset is hidden or not */
  isHidden: boolean;
  /** The data of the asset, this is optional as there are assets that do not have data */
  data?: object;
  /** The resolved hosts of the asset, this is optional as there are assets that do not have resolved hosts */
  resolvedHosts?: string[];
  /** The discovery path of the asset. */
  discoveryPath: AttackSurfaceAssetDiscoveryPathPoint[];
  /**
   * The date when the asset was discovered
   * @format date-time
   */
  discoveredAt: string;
  /**
   * The date when the asset was last seen
   * @format date-time
   */
  lastSeenAt: string;
  /** The confidence level of the asset */
  confidence: AttackSurfaceConfidenceLevel;
}

/** Refers to a specific point in the discovery path of an asset. */
export interface AttackSurfaceAssetDiscoveryPathPoint {
  assetId: string;
  description: string;
}

/** The confidence level of the asset */
export enum AttackSurfaceConfidenceLevel {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

/** The type of the target */
export enum AttackSurfaceAssetType {
  ORG_STUB = "ORG_STUB",
  DOMAIN = "DOMAIN",
  SUBDOMAIN = "SUBDOMAIN",
  DNS_NAME = "DNS_NAME",
  ASN = "ASN",
  IP_ADDRESS = "IP_ADDRESS",
  OPEN_TCP_PORT = "OPEN_TCP_PORT",
  SOCIAL = "SOCIAL",
  CODE_REPOSITORY = "CODE_REPOSITORY",
  STORAGE_BUCKET = "STORAGE_BUCKET",
  AZURE_TENANT = "AZURE_TENANT",
  EMAIL_ADDRESS = "EMAIL_ADDRESS",
  TECHNOLOGY = "TECHNOLOGY",
  URL = "URL",
  PROTOCOL = "PROTOCOL",
}

export interface AttackSurfaceTarget {
  /** The internal ID of the target */
  id: string;
  /** The name of the target, e.g. the domain name, the IP address, the hostname, etc. */
  name: string;
  /** Type of the target, might be a domain, an IP address, a hostname, etc. */
  type: AttackSurfaceAssetType;
}

export interface AttackSurfaceScanInfo {
  /** The unique identifier of the repository. */
  assetId: string;
  /**
   * The date and time the scan was last run.
   * @format date-time
   */
  lastRun?: string;
  /**
   * The date and time the scan is scheduled to run next.
   * @format date-time
   */
  nextRun?: string;
  /** Whether the scan is currently running. */
  isScanning: boolean;
}

export interface UpdateAttackSurfaceAssetRequest {
  isHidden?: boolean;
}

export interface SecurityTrainingSection {
  /** @format uuid */
  id: string;
  title: string;
  description: string;
  order: number;
  content?: string;
  contentWordCount?: number;
}

export interface SecurityTrainingModule {
  /** @format uuid */
  id: string;
  title: string;
  description: string;
  icon: string;
  sections: SecurityTrainingSection[];
}

export interface UpdateSecurityTrainingModuleRequestBody {
  title: string;
  icon: string;
  sections: {
    /** @format uuid */
    id?: string;
    title: string;
    description: string;
    order: number;
    content: string;
  }[];
}

export interface UserSecurityTrainingProgressModuleData {
  /** @format uuid */
  id: string;
  name: string;
  /** @format date-time */
  completedAt?: string;
}

export interface UserSecurityTrainingProgress {
  /** @format uuid */
  id: string;
  email: string;
  fullName: string;
  isCompliant: boolean;
  /** @format date-time */
  compliantAt?: string;
  completedModules: UserSecurityTrainingProgressModuleData[];
}

export interface MyProgressSecurityTrainingSection {
  /** @format uuid */
  sectionId: string;
  isCompleted: boolean;
}

export interface MyProgressSecurityTrainingModule {
  /**
   * The id of the security training module
   * @format uuid
   */
  moduleId: string;
  moduleTitle: string;
  /** @format date-time */
  completedAt?: string;
  sectionProgress: MyProgressSecurityTrainingSection[];
}

export interface MyProgressUpdateSectionProgressRequestBody {
  /** @format uuid */
  sectionId: string;
  isCompleted: boolean;
}

export interface HModuleLanding {
  landing_type: HModuleLandingType;
  landing_html?: string;
  items: HModuleLandingItem[];
}

export enum HModuleLandingType {
  List = "list",
  File = "file",
}

export interface HModuleLandingItem {
  id: string;
  name: string;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  updated_at?: string;
}

export interface HModuleAction {
  id: string;
  label: string;
}

export interface TenantHModuleModule {
  name: string;
  isBeta: boolean;
  actions: HModuleAction[];
  emptyStateTitle?: string;
  emptyStateDescription?: string;
}

export interface TenantHModuleTab {
  name: string;
  modules: string[];
}

export interface TenantHModuleMeta {
  modules: Record<string, TenantHModuleModule>;
  tab_struct: Record<string, TenantHModuleTab>;
}

export interface Activity {
  /**
   * The id of the activity
   * @format uuid
   */
  id: string;
  /**
   * The id of the tenant
   * @format uuid
   */
  tenantId: string;
  tenantMember?: TenantMember;
  /** The action that was performed */
  content: string;
  type: ActivityType;
  /**
   * The id of the control
   * @format uuid
   */
  controlId?: string;
  /**
   * The date and time the activity was created
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the activity was updated
   * @format date-time
   */
  updatedAt: string;
  /** Whether the activity was authored by OneLeet */
  isAuthoredByOneleet?: boolean;
}

export interface ActivityList {
  pagination?: PaginationResponse;
  rows?: Activity[];
}

export enum ActivityType {
  COMMENT = "COMMENT",
  ACTION = "ACTION",
}

export enum QuestionnaireStatus {
  AUTOFILL_IN_PROGRESS = "AUTOFILL_IN_PROGRESS",
  IN_REVIEW = "IN_REVIEW",
  COMPLETED = "COMPLETED",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

export enum QuestionnaireQuestionStatus {
  NEED_REVIEW = "NEED_REVIEW",
  NEED_RESPONSE = "NEED_RESPONSE",
  ACCEPTED = "ACCEPTED",
}

export interface QuestionnaireProgress {
  /** The number of accepted questions */
  acceptedQuestions: number;
  /** The total number of questions */
  totalQuestions: number;
  /** The date the questionnaire was started */
  dateStarted: string;
  /** The date the questionnaire was completed */
  dateCompleted: string;
}

export type QuestionnaireDetail = QuestionnaireSummary & {
  questions: QuestionnaireQuestion[];
};

export interface QuestionnaireSummary {
  /** The ID of the questionnaire */
  id: string;
  /** The title of the questionnaire */
  title: string;
  /** The due date of the questionnaire */
  dueDate: string;
  /** The status of the questionnaire */
  status: QuestionnaireStatus;
  owner: {
    /** The ID of the owner */
    id?: string;
    /** The name of the owner */
    name?: string;
  };
  progress: QuestionnaireProgress;
}

export type QuestionnaireList = QuestionnaireSummary[];

export interface QuestionnaireQuestion {
  /** The ID of the question */
  id: string;
  /** The title of the question */
  title: string;
  /** The status of the question */
  status: QuestionnaireQuestionStatus;
  /** The details of the question */
  details: string;
  /** The original answer of the question */
  originalAnswer: string;
  /** The answer of the question */
  answer: string;
  /** The order of the question */
  order?: number;
  /** Whether the question was answered by AI */
  answeredByAI?: boolean;
  /** The date and time the question was answered */
  answeredAt?: string;
  answeredBy?: {
    /** The ID of the user */
    id?: string;
    /** The name of the user */
    name?: string;
  };
}

export interface UploadNewQuestionnaireBody {
  /** The title of the questionnaire */
  title: string;
  /** The due date of the questionnaire */
  dueDate: string;
  /** The ID of the owner */
  ownerId: string;
  /** The content of the questionnaire in csv format */
  questionnaire: string;
}

export interface UpdateQuestionnaireBody {
  /** The title of the questionnaire */
  title: string;
  /** The due date of the questionnaire */
  dueDate: string;
  /** The ID of the owner */
  ownerId: string;
}

export interface UpdateQuestionnaireOwnerBody {
  /** The ID of the owner */
  ownerId: string;
}

export interface UpdateQuestionnaireQuestionAnswerBody {
  /** The answer of the question */
  answer: string;
}

/** Action taken to resolve an exposed account */
export enum ExposedAccountResolutionAction {
  ACCESS_RESTRICTED = "ACCESS_RESTRICTED",
  ACCOUNT_DELETED = "ACCOUNT_DELETED",
  ACCOUNT_SUSPENDED = "ACCOUNT_SUSPENDED",
  ALTERNATIVE_AUTH_ENABLED = "ALTERNATIVE_AUTH_ENABLED",
  EMAIL_CHANGED = "EMAIL_CHANGED",
  FALSE_POSITIVE = "FALSE_POSITIVE",
  NO_ACTION_REQUIRED = "NO_ACTION_REQUIRED",
  PASSWORD_CHANGED = "PASSWORD_CHANGED",
  TWO_FACTOR_AUTH_ENABLED = "TWO_FACTOR_AUTH_ENABLED",
}

/** Current status of the resolution process */
export enum ExposedAccountResolutionStatus {
  NEW = "NEW",
  RESOLVED = "RESOLVED",
}

export interface ExposedAccount {
  /** Unique identifier for the exposed account */
  id?: string;
  /**
   * Timestamp when this record was created
   * @format date-time
   */
  createdAt?: string;
  /**
   * Timestamp when this record was last updated
   * @format date-time
   */
  updatedAt?: string;
  /** Associated user account */
  user?: User;
  /** UUID of the associated user */
  userId?: string;
  /** Email address found in the breach */
  email?: string;
  /** Name of the breach (as per HIBP) */
  breachName?: string;
  /**
   * Date the breach occurred
   * @format date-time
   */
  breachedAt?: string;
  /**
   * Date the breach was added to HIBP
   * @format date-time
   */
  addedAt?: string;
  /**
   * Timestamp when the breach was detected by the system
   * @format date-time
   */
  detectedAt?: string;
  /** Data types that were exposed in the breach */
  dataClasses?: string[];
  /** Title of the breach */
  breachTitle?: string;
  /** Domain associated with the breach */
  breachDomain?: string;
  /** HTML description of the breach */
  breachDescription?: string | null;
  /** Number of accounts exposed in the breach */
  totalUsersBreached?: number;
  /** Whether the breach is verified by HIBP */
  isVerified?: boolean;
  /** Whether the breach is suspected to be fabricated */
  isFabricated?: boolean;
  /** Whether the breach contains sensitive information */
  isSensitive?: boolean;
  /** Whether the breach has been retired from HIBP */
  isRetired?: boolean;
  /** Whether the breach is a known spam list */
  isSpamList?: boolean;
  /** Whether the breach was malware-related */
  isMalware?: boolean;
  /** Optional logo path for the breached service */
  logoPath?: string | null;
  /** Current resolution status */
  resolutionStatus?: ExposedAccountResolutionStatus;
  /** Actions taken to resolve the exposure */
  resolutionActions?: ExposedAccountResolutionAction[];
  /**
   * Timestamp when the account was resolved
   * @format date-time
   */
  resolvedAt?: string | null;
  /** UUID of the reviewer */
  reviewedById?: string | null;
  /** The reviewer of the account */
  reviewedBy?: TenantMember | null;
  /** Count of notifications sent to the user */
  notificationsSent?: number;
  /**
   * When the last notification was sent
   * @format date-time
   */
  notificationLastSentAt?: string | null;
}

export interface ExposedAccountUpdateRequest {
  /** Current resolution status */
  resolutionStatus?: ExposedAccountResolutionStatus;
  /** Resolution actions taken. */
  resolutionActions?: ExposedAccountResolutionAction[] | null;
}

/** The additional configuration of the connection. */
type BaseNull = object | null;

type BaseNullIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type AbstractNull = object;

type AbstractNullIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type DiscriminatorNull = object;

type DiscriminatorNullIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type BaseCreateConnectionRequest = object;

type BaseCreateConnectionRequestIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type InternalNull = object;

type InternalNullIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type BaseReconnectConnectionRequest = object;

type BaseReconnectConnectionRequestIntegrationTypeIdMapping<Key, Type> = {
  integrationTypeId: Key;
} & Type;

type PolymorphNull = object;

type PolymorphNullTypeMapping<Key, Type> = {
  type: Key;
} & Type;

type BaseAppleMdmCommandRequest = object;

type BaseAppleMdmCommandRequestCommandMapping<Key, Type> = {
  command: Key;
} & Type;

type BaseCreateUpdateTenantVendor = object;

type BaseCreateUpdateTenantVendorOperationMapping<Key, Type> = {
  operation: Key;
} & Type;
